import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BasicValidators } from "../shared/basic-validators";

import { LaudosTecnicosModel } from "./laudos-tecnicos.model";
import { LaudosTecnicosService } from './laudos-tecnicos.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

// Services para os combos
import { ClientesService } from "../clientes/clientes.service";
import { PaisesService } from "../paises/paises.service";
import { TransportadorasService } from "../transportadoras/transportadoras.service";
import { TipoUnidadeService } from "../laudos-cd/tipo-unidade.service";
import { TipoTransporteService } from "../laudos-cd/tipo-transporte.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { StakeholdersTecnicosService } from "../laudos-tecnicos-stakeholders/stakeholders.service";
import { ResponsaveisTecnicosService } from "../laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.service";
import { MercadoriasEmbalagensService } from "../mercadorias-embalagens/mercadorias-embalagens.service";
import { LabelFotosLaudosTecnicosService } from "./label-fotos-laudostecnicos.service";
import { UnidadesService } from "../unidades/unidades.service";
import { TiposClientesService } from "../clientes/tipos-clientes.service";
import { MercadoriasCategoriasService } from "../mercadorias-categorias/mercadorias-categorias.service";
import { ObservacoesLaudosService } from "../laudos-cd-observacoes/observacoes-laudos.service";
import { UnidadesMedidasService } from "../unidades-medidas/unidades-medidas.service";
import { ColoracaoService } from "../laudos-cd-coloracao/coloracao.service";
import { ExportadoresService } from "../exportadores/exportadores.service";
import { TerminaisService } from "../terminais/terminais.service";
import { ArmadoresService } from "../armadores/armadores.service";
import { LocaisService } from "../locais/locais.service";

declare let $, swal: any;

@Component({
  selector: 'app-laudos-tecnicos-form',
  templateUrl: './laudos-tecnicos-form.component.html'
})
export class LaudosTecnicosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  laudo: LaudosTecnicosModel = new LaudosTecnicosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  cacheTimestamp: number = new Date().getTime();
  prevTermografosState: any[] = [];
  mascaraTransporte: any = false;

  importSourceType: string = 'laudos-tecnicos';
  numeroLaudoImportar: string = '';
  laudoEncontradoParaImportacao: any = null;
  buscandoLaudoImportar: boolean = false;
  mensagemErroImportacao: string = '';
  mercadoriaConfig: any = null;

  listClientes = [];
  listExportadores = [];
  listTerminal = [];
  listArmador = [];
  listLocais = [];
  listUnidades = [];
  listPaises = [];
  listTransportadoras = [];
  listTiposUnidade = [];
  listTiposTransporte = [];
  listProdutos = [];
  listVariedades = [];
  listEmbalagens = [];
  listCategorias = [];
  listUnidadesMedidas = [];
  listTodasUnidadesMedidas = [];
  listColoracoes = [];
  listIndicesConclusao = [];
  indicesConclusaoSelecionados = [];
  modelIndicesConclusaoSelecionados = [];
  listShelfLifeLabels = [
    { id: 'dias', nome: 'Dias' },
    { id: 'semanas', nome: 'Semanas' },
    { id: 'meses', nome: 'Meses' },
    { id: 'anos', nome: 'Anos' }
  ];
  listStakeholders = [];
  stakeholdersSelecionados = [];
  listResponsaveisTecnicos = [];
  responsaveisTecnicosSelecionados = [];
  listObservacoes = [];
  observacoesSelecionadas = [];
  listCores = [];
  temperaturasCount: number = 3;
  temperaturasTriplets: any[] = [];
  tempMin: number = null;
  tempMax: number = null;
  tempMedia: number = null;
  
  pressaoCount: number = 1;
  pressaoTriplets: any[] = [];
  pressaoMin: number = null;
  pressaoMax: number = null;
  pressaoMedia: number = null;
  pressao_polpa_med: string = '';

  brixCount: number = 1;
  brixTriplets: any[] = [];
  brixMin: number = null;
  brixMax: number = null;
  brixMedia: number = null;
  tamanhoCalibreCount: number = 1;
  tamanhoCalibreTriplets: any[] = [];

  fabricacaoCount: number = 1;
  fabricacaoTriplets: any[] = [];
  validadeCount: number = 1;
  validadeTriplets: any[] = [];

  pesagens: any[] = [];


  listFotos = [];
  listLabelsFotos = [];
  labelsSelecionados = [];
  labelsDefeitosSelecionados = [];
  panelCollapsed = [];
  defeitosSemIndiceCollapsed = false;
  photoPanelCollapsed = {};
  ordemCategorias = [];
  listDefeitos = [];
  listIndicesClassificacao = [];
  listIndicesClassificacaoCalculado = [];
  formula_odr: string = null;
  odr_inputs_config: any[] = [];
  odr_valores: any = {};
  odr_calculado: number = null;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private laudosService: LaudosTecnicosService,
    private clientesService: ClientesService,
    private paisesService: PaisesService,
    private transportadorasService: TransportadorasService,
    private tipoUnidadeService: TipoUnidadeService,
    private tipoTransporteService: TipoTransporteService,
    private mercadoriasService: MercadoriasService,
    private mercadoriasEmbalagensService: MercadoriasEmbalagensService,
    private mercadoriasCategoriasService: MercadoriasCategoriasService,
    private stakeholdersService: StakeholdersTecnicosService,
    private responsaveisTecnicosService: ResponsaveisTecnicosService,
    private observacoesService: ObservacoesLaudosService,
    private labelFotosService: LabelFotosLaudosTecnicosService,
    private unidadesService: UnidadesService,
    private tiposClientesService: TiposClientesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global,
    private translateService: TranslateService,
    private unidadesMedidasService: UnidadesMedidasService,
    private coloracaoService: ColoracaoService,
    private exportadoresService: ExportadoresService,
    private terminaisService: TerminaisService,
    private armadoresService: ArmadoresService,
    private locaisService: LocaisService
  ) {
    this.form = formBuilder.group({
      id_laudo_tecnico: [],
      id_cliente: ['', Validators.required],
      id_exportador: ['', Validators.required],
      id_terminal: ['', Validators.required],
      id_armador: [],
      id_unidade: ['', Validators.required],
      id_pais_origem: ['', Validators.required],
      id_transportadora: ['', Validators.required],
      id_tipo_unidade: ['', Validators.required],
      id_tipo_transporte: ['', Validators.required],
      id_produto: ['', Validators.required],
      id_variedade: [],
      id_embalagem: [],
      id_categoria: [],
      invoice: [],
      referencia: [],
      nf_importacao: [],
      identificacao_transporte: [],
      lacre_transporte: [],
      lote: [],
      quantidade: [],
      vol_analisados: [],
      shelf_life: [],
      shelf_life_label: [],
      marca: [],
      coloracao: [],
      temperaturas_polpa: [],
      temp_0: [],
      temp_1: [],
      temp_2: [],
      temp_3: [],
      temp_4: [],
      temp_5: [],
      temp_6: [],
      temp_7: [],
      temp_8: [],
      pressao_polpa: [],
      brix: [],
      tamanho_calibre: [],
      data_descarga: [],
      data_fabricacao: [],
      data_validade: [],
      estivagem: [],
      carga_avancada_porta: [],
      carga_avancada_teto: [],
      odor: [],
      paletizacao: [],
      avarias_carreta: [],
      prioridade_vendas: [],
      peso_liquido_vol: [true],
      embalagem_danificada: [],
      sem_rotulo: [],
      sem_calibre: [],
      calibre_min_0: [],
      calibre_max_0: [],
      calibre_med_0: [],
      calibre_afericao_0: [],
      sem_pesagem: [],
      rotulo_divergente: [],
      termografo_inicializado: [true],
      termografo_status: [true],
      termografo_numero: [],
      termografo_temperatura_minima: [],
      termografo_temperatura_maxima: [],
      termografo_temperatura_media: [],
      termografo_excesso_transit_time: [false],
      termografo_fora_alcance: [false],
      termografo_com_defeito: [false],
      termografo_fora_tolerancia: [false],
      termografo_foto: [],
      stakeholders: [],
      responsaveis_tecnicos: [],
      observacoes: [],
      exibir_odr: [false],
      exibir_informacoes_bl: [true],
      setpoint: [],
      setpoint_off: [false],
      airtemperature: [],
      airtemperature_off: [false],
      ventilacao_container: [],
      ventilacao_container_unidade: [],
      sem_ventilacao_container: [false],
      ventilacao_container_automatico: [false],
      ventilacao_bl: [],
      ventilacao_bl_unidade: [],
      ventilacao_bl_fechado: [false],
      temperatura_bl: [],
      id_importador: [],
      data_inspecao: [],
      id_coloracao: [],
      rotulagem: [true],
      temperatura_polpa_status: [true],
      temperatura_polpa_exibir: [true],
      pressao_poupa_status: [true],
      pressao_polpa_exibir: [true],
      estivagem_exibir: [true],
      paletizacao_exibir: [true],
      brix_exibir: [true],
      brix_status: [true],
      bl_crt_mic: [],
      lpco: [],
      id_local_embarque: [],
      id_local_chegada: [],
      data_embarque: [],
      data_chegada: [],
      bl_to_port: [],
      crt_to_house: [],
      fotos: [],
      comentarios_exibir: [false],
      comentarios_pt: [],
      comentarios_en: [],
      comentarios_es: [],
      comentarios_cor: [null]
    });

    this.listCores = [{
      "nome": "Verde",
      "valor": 1
    },{
      "nome": "Amarelo",
      "valor": 2
    },{
      "nome": "Vermelho",
      "valor": 0
    }];

    this.form.controls['comentarios_exibir'].valueChanges.subscribe(exibir => {
      this.atualizarValidadoresComentarios(exibir);
    });
  }

  atualizarValidadoresComentarios(exibir: boolean) {
    const campos = ['comentarios_pt', 'comentarios_en', 'comentarios_es'];
    campos.forEach(campo => {
      const control = this.form.controls[campo];
      if (control) {
        if (exibir) {
          control.setValidators([Validators.required, Validators.minLength(3)]);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      }
    });
  }

  ngOnInit() {

    this.carregarListas();

    this.form.get('id_tipo_transporte').valueChanges.subscribe(val => {
      setTimeout(() => {
        this.atualizarMascaraEValidador(val);
      });
    });

    const cleanUrl = this.router.url.split('?')[0];
    if (cleanUrl.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    if (cleanUrl.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_laudo_tecnico'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarLaudoTecnico');
      } else {
        this.title = id ? this.func.traduzir('front.editarLaudoTecnico') : this.func.traduzir('front.addLaudoTecnico');
      }

      if (!id) {
        const duplicateId = this.route.snapshot.queryParams['duplicate_id'];
        if (duplicateId) {
          this.title = this.func.traduzir('front.duplicarLaudoTecnico');
          this.laudosService.getById(duplicateId, ['stakeholders', 'responsaveis_tecnicos', 'fotos', 'labels', 'labels_defeitos', 'defeitos', 'odr_valores', 'observacoes', 'armador'])
            .subscribe(
              json => {
                let original = json.Payload[0];
                this.laudo = new LaudosTecnicosModel();

                // 1. Copy allowed general and transport fields:
                this.laudo.id_cliente = original.id_cliente;
                this.laudo.id_importador = original.id_importador;
                this.laudo.id_exportador = original.id_exportador;
                this.laudo.id_terminal = original.id_terminal;
                this.laudo.id_armador = original.id_armador;
                this.laudo.id_unidade = original.id_unidade;
                this.laudo.id_pais_origem = original.id_pais_origem;
                this.laudo.id_transportadora = original.id_transportadora;
                this.laudo.id_tipo_unidade = original.id_tipo_unidade;
                this.laudo.id_tipo_transporte = original.id_tipo_transporte;
                this.laudo.id_produto = original.id_produto;

                this.laudo.invoice = original.invoice;
                this.laudo.referencia = original.referencia;
                this.laudo.identificacao_transporte = original.identificacao_transporte;
                this.laudo.lacre_transporte = original.lacre_transporte;
                this.laudo.estivagem = original.estivagem;
                this.laudo.estivagem_exibir = original.estivagem_exibir;
                this.laudo.carga_avancada_porta = original.carga_avancada_porta;
                this.laudo.carga_avancada_teto = original.carga_avancada_teto;
                this.laudo.paletizacao = original.paletizacao;
                this.laudo.paletizacao_exibir = original.paletizacao_exibir;
                this.laudo.avarias_carreta = original.avarias_carreta;
                this.laudo.bl_crt_mic = original.bl_crt_mic;
                this.laudo.lpco = original.lpco;
                this.laudo.id_local_embarque = original.id_local_embarque;
                this.laudo.id_local_chegada = original.id_local_chegada;
                this.laudo.data_embarque = original.data_embarque;
                this.laudo.data_chegada = original.data_chegada;
                this.laudo.bl_to_port = original.bl_to_port;
                this.laudo.crt_to_house = original.crt_to_house;
                this.laudo.exibir_informacoes_bl = original.exibir_informacoes_bl;

                // 2. Explicitly do NOT copy Data Inspeção and Data Descarga
                this.laudo.data_inspecao = null;
                this.laudo.data_descarga = null;

                // 3. Explicitly do NOT copy Análise do Produto fields (except id_produto)
                this.laudo.id_variedade = null;
                this.laudo.id_embalagem = null;
                this.laudo.lote = null;
                this.laudo.quantidade = null;
                this.laudo.vol_analisados = '10';
                this.laudo.id_categoria = null;
                this.laudo.marca = null;
                this.laudo['coloracao'] = null;
                this.laudo.id_coloracao = null;
                this.laudo.shelf_life = '10';
                this.laudo.shelf_life_label = 'dias';
                this.laudo.embalagem_danificada = false;
                this.laudo.prioridade_vendas = false;
                this.laudo.odor = true;
                this.laudo.rotulagem = true;
                this.laudo.sem_rotulo = false;
                this.laudo.sem_calibre = false;
                this.laudo.sem_pesagem = false;
                this.laudo.rotulo_divergente = false;
                this.laudo.temperaturas_polpa = null;
                this.laudo.temperatura_polpa_status = true;
                this.laudo.temperatura_polpa_exibir = true;
                this.laudo.pressao_polpa = null;
                this.laudo.pressao_poupa_status = true;
                this.laudo.pressao_polpa_exibir = true;
                this.laudo.estivagem_exibir = true;
                this.laudo.paletizacao_exibir = true;
                this.laudo.brix = null;
                this.laudo.brix_exibir = true;
                this.laudo.brix_status = true;
                if (original.calibres) {
                  try {
                    let rawCalibres = typeof original.calibres === 'string' ? JSON.parse(original.calibres) : JSON.parse(JSON.stringify(original.calibres));
                    if (Array.isArray(rawCalibres)) {
                      this.laudo.calibres = rawCalibres;
                    } else {
                      this.laudo.calibres = [];
                    }
                  } catch (e) {
                    this.laudo.calibres = [];
                  }
                } else {
                  this.laudo.calibres = [];
                }
                this.laudo.tamanho_calibre = original.tamanho_calibre;
                this.laudo.data_fabricacao = null;
                this.laudo.data_validade = null;
                this.laudo.nf_importacao = original.nf_importacao;

                // 4. Do NOT copy Pesagem (initialize empty/defaults)
                this.laudo.peso_liquido_vol = true;
                this.laudo.pesagem = null;
                this.laudo.pesagem_tara = null;
                this.laudo.pesagem_diferenca_final = null;
                this.pesagens = [{
                  volumes: [''],
                  tara: '',
                  peso_liquido: '',
                  diferenca_final: '',
                  exibir: false
                }];
                this.rebuildPesagemControls();
                this.atualizarPesagemTriplets(0);
                this.calcularPesoMedio(0);

                // 5. Do NOT copy Termógrafo (initialize empty)
                this.laudo.termografos = [];
                this.pressao_polpa_med = '';

                // 6. Do NOT copy Observações (initialize empty)
                this.observacoesSelecionadas = [];

                // 7. Do NOT copy Cálculo ODR (initialize empty/defaults)
                this.odr_valores = {};
                this.laudo.exibir_odr = false;

                // 8. Do NOT copy Fotos (initialize empty)
                this.listFotos = [];
                this.laudo['fotos'] = [];
                
                if (original.labels) {
                  this.labelsSelecionados = original.labels.map(l => l.id);
                } else {
                  this.labelsSelecionados = [];
                }

                if (original.labels_defeitos) {
                  this.labelsDefeitosSelecionados = original.labels_defeitos.map(d => d.id);
                } else {
                  this.labelsDefeitosSelecionados = [];
                }

                // Construct initial order of categories based on pivot.ordem
                let combined = [];
                if (original.labels) {
                  original.labels.forEach(l => {
                    combined.push({
                      uid: 'label:' + l.id,
                      ordem: l.pivot && l.pivot.ordem !== undefined ? parseInt(l.pivot.ordem) : 999
                    });
                  });
                }
                if (original.labels_defeitos) {
                  original.labels_defeitos.forEach(d => {
                    combined.push({
                      uid: 'defeito:' + d.id,
                      ordem: d.pivot && d.pivot.ordem !== undefined ? parseInt(d.pivot.ordem) : 999
                    });
                  });
                }
                combined.sort((a, b) => a.ordem - b.ordem);
                this.ordemCategorias = combined.map(c => c.uid);

                // Copy stakeholders and responsaveis_tecnicos if they exist in original:
                if (original.stakeholders) {
                  this.stakeholdersSelecionados = original.stakeholders.map(s => s.id);
                } else {
                  this.stakeholdersSelecionados = [];
                }
                if (original.responsaveis_tecnicos) {
                  this.responsaveisTecnicosSelecionados = original.responsaveis_tecnicos.map(rt => rt.id);
                } else {
                  this.responsaveisTecnicosSelecionados = [];
                }

                // Patch form with the cloned laudo model data
                let laudoData: any = Object.assign({}, this.laudo);
                delete laudoData.fotos;
                this.form.patchValue(laudoData);
                this.form.controls['id_laudo_tecnico'].setValue(null); // Ensure ID is null
                this.form.controls['data_inspecao'].setValue(null);
                this.form.controls['data_descarga'].setValue(null);

                this.temperaturasCount = 3;
                this.form.controls['temp_0'].setValue('');
                this.form.controls['temp_1'].setValue('');
                this.form.controls['temp_2'].setValue('');
                this.laudo['temp_0'] = '';
                this.laudo['temp_1'] = '';
                this.laudo['temp_2'] = '';
                this.atualizarTriplets();
                this.calcularMinMaxMedia();

                this.pressaoCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('pressao_0', control);
                this.laudo['pressao_0'] = '';
                this.atualizarPressaoTriplets();
                this.calcularMinMaxMediaPressao();

                this.brixCount = 1;
                let controlBrix = new FormControl('', []);
                this.form.setControl('brix_0', controlBrix);
                this.laudo['brix_0'] = '';
                this.atualizarBrixTriplets();
                this.calcularMinMaxMediaBrix();

                if (this.laudo.tamanho_calibre) {
                  let tcData = this.laudo.tamanho_calibre.split(',').map(v => v.trim()).filter(v => v !== '');
                  if (tcData.length > 0) {
                    this.tamanhoCalibreCount = tcData.length;
                    tcData.forEach((tc, i) => {
                      let control = new FormControl(tc, []);
                      this.form.setControl('tamanho_calibre_' + i, control);
                      this.laudo['tamanho_calibre_' + i] = tc;
                    });
                  } else {
                    this.tamanhoCalibreCount = 1;
                    let control = new FormControl('', []);
                    this.form.setControl('tamanho_calibre_0', control);
                    this.laudo['tamanho_calibre_0'] = '';
                  }
                } else {
                  this.tamanhoCalibreCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('tamanho_calibre_0', control);
                  this.laudo['tamanho_calibre_0'] = '';
                }
                this.atualizarTamanhoCalibreTriplets();

                this.fabricacaoCount = 1;
                let controlFabricacao = new FormControl('', []);
                this.form.setControl('data_fabricacao_0', controlFabricacao);
                this.laudo['data_fabricacao_0'] = '';
                this.atualizarFabricacaoTriplets();

                this.validadeCount = 1;
                let controlValidade = new FormControl('', []);
                this.form.setControl('data_validade_0', controlValidade);
                this.laudo['data_validade_0'] = '';
                this.atualizarValidadeTriplets();

                // 9. Load varieties, grading indexes and defaults for the product, keeping defects uncopied/clean
                if (this.laudo.id_produto) {
                  this.changeMercadoria(this.laudo.id_produto, false, original.indices_conclusao);
                } else {
                  this.rebuildCalibresControls();
                }

                this.atualizarEstivagem();
              },
              error => {
                this.func.showErro(error.json());
              }
            );
          return;
        }

        this.temperaturasCount = 3;
        this.form.controls['temp_0'].setValue('');
        this.form.controls['temp_1'].setValue('');
        this.form.controls['temp_2'].setValue('');
        this.laudo['temp_0'] = '';
        this.laudo['temp_1'] = '';
        this.laudo['temp_2'] = '';
        this.atualizarTriplets();
        this.calcularMinMaxMedia();

        this.pressaoCount = 1;
        let control = new FormControl('', []);
        this.form.setControl('pressao_0', control);
        this.laudo['pressao_0'] = '';
        this.atualizarPressaoTriplets();
        this.calcularMinMaxMediaPressao();

        this.brixCount = 1;
        let controlBrix = new FormControl('', []);
        this.form.setControl('brix_0', controlBrix);
        this.laudo['brix_0'] = '';
        this.atualizarBrixTriplets();
        this.calcularMinMaxMediaBrix();

        this.tamanhoCalibreCount = 1;
        let controlTamanhoCalibre = new FormControl('', []);
        this.form.setControl('tamanho_calibre_0', controlTamanhoCalibre);
        this.laudo['tamanho_calibre_0'] = '';
        this.atualizarTamanhoCalibreTriplets();

        this.fabricacaoCount = 1;
        let controlFabricacao = new FormControl('', []);
        this.form.setControl('data_fabricacao_0', controlFabricacao);
        this.laudo['data_fabricacao_0'] = '';
        this.atualizarFabricacaoTriplets();

        this.validadeCount = 1;
        let controlValidade = new FormControl('', []);
        this.form.setControl('data_validade_0', controlValidade);
        this.laudo['data_validade_0'] = '';
        this.atualizarValidadeTriplets();

        this.pesagens = [{
          volumes: [''],
          tara: '',
          peso_liquido: '',
          diferenca_final: '',
          exibir: false
        }];
        this.laudo.termografos = [];
        this.rebuildPesagemControls();
        this.atualizarPesagemTriplets(0);
        this.calcularPesoMedio(0);
        this.atualizarEstivagem();

        this.laudo.vol_analisados = '10';
        if (this.form.controls['vol_analisados']) {
          this.form.controls['vol_analisados'].setValue('10');
        }
        this.laudo.shelf_life = '10';
        if (this.form.controls['shelf_life']) {
          this.form.controls['shelf_life'].setValue('10');
        }
        this.laudo.shelf_life_label = 'dias';
        if (this.form.controls['shelf_life_label']) {
          this.form.controls['shelf_life_label'].setValue('dias');
        }
        this.laudo.paletizacao = true;
        if (this.form.controls['paletizacao']) {
          this.form.controls['paletizacao'].setValue(true);
        }

        return;
      }

      this.laudosService.getById(id, ['stakeholders', 'responsaveis_tecnicos', 'fotos', 'labels', 'labels_defeitos', 'defeitos', 'odr_valores', 'observacoes', 'armador'])
        .subscribe(
          json => {
            const docNumero = json.Payload[0].numero || json.Payload[0].id_laudo_tecnico;
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarLaudoTecnico') + ': ' + docNumero;
            } else {
              this.title = this.func.traduzir('front.visualizarLaudoTecnico') + ': ' + docNumero;
            }

            this.laudo = json.Payload[0];
            if (this.laudo.calibres) {
              try {
                let rawCalibres = typeof this.laudo.calibres === 'string' ? JSON.parse(this.laudo.calibres) : this.laudo.calibres;
                if (Array.isArray(rawCalibres)) {
                  this.laudo.calibres = rawCalibres;
                } else {
                  this.laudo.calibres = [];
                }
              } catch (e) {
                this.laudo.calibres = [];
              }
            } else {
              this.laudo.calibres = [];
            }
            if (this.laudo.estivagem_exibir === undefined || this.laudo.estivagem_exibir === null) {
              this.laudo.estivagem_exibir = true;
            }
            if (this.laudo.paletizacao_exibir === undefined || this.laudo.paletizacao_exibir === null) {
              this.laudo.paletizacao_exibir = true;
            }
            if (this.laudo.termografos) {
              let tgList = [];
              try {
                tgList = typeof this.laudo.termografos === 'string' ? JSON.parse(this.laudo.termografos) : this.laudo.termografos;
              } catch (e) {
                tgList = [];
              }
              if (Array.isArray(tgList) && tgList.length > 0) {
                this.laudo.termografos = tgList.map(tg => {
                  if (!tg.id) {
                    tg.id = 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000);
                  }
                  return tg;
                });
                this.laudo.termografos.forEach((tg, i) => {
                  this.registrarControlesTermografo(i, tg);
                });
              } else {
                this.laudo.termografos = [];
              }
            } else {
              this.laudo.termografos = [];
            }
            this.pressao_polpa_med = this.laudo.pressao_polpa_med || '';
            this.listFotos = (this.laudo['fotos'] || []).map(f => {
              if (!f.hasOwnProperty('id_label_foto') || f.id_label_foto === undefined) {
                f.id_label_foto = null;
              }
              if (!f.hasOwnProperty('id_defeito') || f.id_defeito === undefined) {
                f.id_defeito = null;
              }
              f._categoria_id = f.id_label_foto ? 'label:' + f.id_label_foto : (f.id_defeito ? 'defeito:' + f.id_defeito : null);
              return f;
            });

            if (this.laudo['labels']) {
              this.labelsSelecionados = this.laudo['labels'].map(l => l.id);
            } else {
              this.labelsSelecionados = [];
            }

            if (this.laudo['labels_defeitos']) {
              this.labelsDefeitosSelecionados = this.laudo['labels_defeitos'].map(d => d.id);
            } else {
              this.labelsDefeitosSelecionados = [];
            }

            // Construct initial order of categories based on pivot.ordem
            let combined = [];
            if (this.laudo['labels']) {
              this.laudo['labels'].forEach(l => {
                combined.push({
                  uid: 'label:' + l.id,
                  ordem: l.pivot && l.pivot.ordem !== undefined ? parseInt(l.pivot.ordem) : 999
                });
              });
            }
            if (this.laudo['labels_defeitos']) {
              this.laudo['labels_defeitos'].forEach(d => {
                combined.push({
                  uid: 'defeito:' + d.id,
                  ordem: d.pivot && d.pivot.ordem !== undefined ? parseInt(d.pivot.ordem) : 999
                });
              });
            }
            combined.sort((a, b) => a.ordem - b.ordem);
            this.ordemCategorias = combined.map(c => c.uid);

            // exibe a tab de fotos
            if (this.route.snapshot.queryParams["abafotos"] == '1') {
              setTimeout(() => {
                $('a[href="#abafotos"]').tab('show');
              }, 500);
            }

            if (this.laudo.id_produto) {
              this.mercadoriasService.getById(this.laudo.id_produto, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"]).subscribe(mJson => {
                this.mercadoriaConfig = mJson.Payload[0];
                this.listVariedades = mJson.Payload[0].variedades || [];
                this.listIndicesClassificacao = mJson.Payload[0].indices_classificacao || [];
                this.listIndicesConclusao = mJson.Payload[0].indices_conclusao || [];

                this.indicesConclusaoSelecionados = [];
                this.modelIndicesConclusaoSelecionados = [];

                this.listIndicesConclusao.forEach((jIndice, j) => {
                  let control = new FormControl('indiceConclusao' + j, [Validators.required]);
                  this.form.setControl('indiceConclusao' + j, control);

                  let matched = false;
                  if (this.laudo.indices_conclusao) {
                    for (let k in jIndice.itens) {
                      for (let q in this.laudo.indices_conclusao) {
                        if (jIndice.nome_pt == this.laudo.indices_conclusao[q].nome_pt) {
                          if (jIndice.itens[k].nome_pt == this.laudo.indices_conclusao[q].valor.nome_pt) {
                            this.modelIndicesConclusaoSelecionados.push(k);
                            matched = true;
                            this.indicesConclusaoSelecionados.push({
                              "nome_pt": jIndice.nome_pt,
                              "nome_en": jIndice.nome_en,
                              "nome_es": jIndice.nome_es,
                              "valor": {
                                "nome_pt": jIndice.itens[k].nome_pt,
                                "nome_en": jIndice.itens[k].nome_en,
                                "nome_es": jIndice.itens[k].nome_es
                              }
                            });
                            break;
                          }
                        }
                      }
                      if (matched) break;
                    }
                  }

                  if (!matched) {
                    this.modelIndicesConclusaoSelecionados.push(null);
                    this.indicesConclusaoSelecionados.push({
                      "nome_pt": jIndice.nome_pt,
                      "nome_en": jIndice.nome_en,
                      "nome_es": jIndice.nome_es,
                      "valor": {
                        "nome_pt": null,
                        "nome_en": null,
                        "nome_es": null
                      }
                    });
                  }
                });

                const mProd = mJson.Payload[0];
                this.formula_odr = mProd.formula_odr;
                this.odr_inputs_config = mProd.odr_inputs_config || [];
                this.odr_valores = {};
                if (this.laudo['odr_valores']) {
                  this.laudo['odr_valores'].forEach(item => {
                    this.odr_valores[item.chave_input] = parseFloat(item.valor);
                  });
                }
                this.odr_inputs_config.forEach(input => {
                  if (this.odr_valores[input.chave] === undefined) {
                    this.odr_valores[input.chave] = 0;
                  }
                  let control = new FormControl('odr_input_' + input.chave, []);
                  this.form.setControl('odr_input_' + input.chave, control);
                });

                let defeitosLaudo = this.laudo['defeitos'] || [];
                this.listDefeitos = [];
                if (mJson.Payload[0].defeitos) {
                  for (let x in mJson.Payload[0].defeitos) {
                    let control = new FormControl('defeito' + x, []);
                    this.form.setControl('defeito' + x, control);
                    let control2 = new FormControl('defeitoAtivo' + x, []);
                    this.form.setControl('defeitoAtivo' + x, control2);

                    let valor = 0.00;
                    let ativo = true;

                    for (let z in defeitosLaudo) {
                      if (defeitosLaudo[z].id_defeito == mJson.Payload[0].defeitos[x].id) {
                        valor = defeitosLaudo[z].valor;
                        ativo = defeitosLaudo[z].ativo;
                      }
                    }

                    this.listDefeitos.push({
                      "id_defeito": mJson.Payload[0].defeitos[x].id,
                      "nome_pt": mJson.Payload[0].defeitos[x].nome_pt,
                      "valor": valor,
                      "ativo": ativo,
                      "is_indice_acumulado": mJson.Payload[0].defeitos[x].is_indice_acumulado,
                      "indices_acumulados": mJson.Payload[0].defeitos[x].indices_acumulados,
                      "ordem": mJson.Payload[0].defeitos[x].ordem
                    });
                  }
                }
                this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
                this.calcularODR();

                let laudoData: any = Object.assign({}, this.laudo);
                delete laudoData.fotos;
                this.form.patchValue(laudoData);

                if (this.laudo.stakeholders) {
                  this.stakeholdersSelecionados = this.laudo.stakeholders.map(s => s.id);
                } else {
                  this.stakeholdersSelecionados = [];
                }

                if (this.laudo.responsaveis_tecnicos) {
                  this.responsaveisTecnicosSelecionados = this.laudo.responsaveis_tecnicos.map(rt => rt.id);
                } else {
                  this.responsaveisTecnicosSelecionados = [];
                }

                if (this.laudo.observacoes) {
                  this.observacoesSelecionadas = this.laudo.observacoes.map(obs => obs.id);
                } else {
                  this.observacoesSelecionadas = [];
                }

                if (this.laudo.temperaturas_polpa) {
                  let temps = typeof this.laudo.temperaturas_polpa === 'string' ? JSON.parse(this.laudo.temperaturas_polpa) : this.laudo.temperaturas_polpa;
                  if (Array.isArray(temps) && temps.length > 0) {
                    let count = temps.length;
                    if (count < 3) count = 3;
                    if (count > 6) count = 6;
                    this.temperaturasCount = count;
                    temps.forEach((t, i) => {
                      if (i < 6) {
                        this.form.controls['temp_' + i].setValue(t);
                        this.laudo['temp_' + i] = t;
                      }
                    });
                    for (let i = temps.length; i < 3; i++) {
                      this.form.controls['temp_' + i].setValue('');
                      this.laudo['temp_' + i] = '';
                    }
                  } else {
                    this.temperaturasCount = 3;
                    this.form.controls['temp_0'].setValue('');
                    this.form.controls['temp_1'].setValue('');
                    this.form.controls['temp_2'].setValue('');
                    this.laudo['temp_0'] = '';
                    this.laudo['temp_1'] = '';
                    this.laudo['temp_2'] = '';
                  }
                } else {
                  this.temperaturasCount = 3;
                  this.form.controls['temp_0'].setValue('');
                  this.form.controls['temp_1'].setValue('');
                  this.form.controls['temp_2'].setValue('');
                  this.laudo['temp_0'] = '';
                  this.laudo['temp_1'] = '';
                  this.laudo['temp_2'] = '';
                }

                this.atualizarTriplets();
                this.calcularMinMaxMedia();

                if (this.laudo.pressao_polpa) {
                  let pressao = typeof this.laudo.pressao_polpa === 'string' ? JSON.parse(this.laudo.pressao_polpa) : this.laudo.pressao_polpa;
                  if (Array.isArray(pressao) && pressao.length > 0) {
                    this.pressaoCount = pressao.length;
                    pressao.forEach((p, i) => {
                      let control = new FormControl(p, []);
                      this.form.setControl('pressao_' + i, control);
                      this.laudo['pressao_' + i] = p;
                    });
                  } else {
                    this.pressaoCount = 1;
                    let control = new FormControl('', []);
                    this.form.setControl('pressao_0', control);
                    this.laudo['pressao_0'] = '';
                  }
                } else {
                  this.pressaoCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('pressao_0', control);
                  this.laudo['pressao_0'] = '';
                }
                this.atualizarPressaoTriplets();
                this.calcularMinMaxMediaPressao();

                if (this.laudo.brix) {
                  let brixData = typeof this.laudo.brix === 'string' ? JSON.parse(this.laudo.brix) : this.laudo.brix;
                  if (Array.isArray(brixData) && brixData.length > 0) {
                    this.brixCount = brixData.length;
                    brixData.forEach((b, i) => {
                      let control = new FormControl(b, []);
                      this.form.setControl('brix_' + i, control);
                      this.laudo['brix_' + i] = b;
                    });
                  } else {
                    this.brixCount = 1;
                    let control = new FormControl('', []);
                    this.form.setControl('brix_0', control);
                    this.laudo['brix_0'] = '';
                  }
                } else {
                  this.brixCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('brix_0', control);
                  this.laudo['brix_0'] = '';
                }
                this.atualizarBrixTriplets();
                this.calcularMinMaxMediaBrix();

                if (this.laudo.tamanho_calibre) {
                  let tcData = this.laudo.tamanho_calibre.split(',').map(v => v.trim()).filter(v => v !== '');
                  if (tcData.length > 0) {
                    this.tamanhoCalibreCount = tcData.length;
                    tcData.forEach((tc, i) => {
                      let control = new FormControl(tc, []);
                      this.form.setControl('tamanho_calibre_' + i, control);
                      this.laudo['tamanho_calibre_' + i] = tc;
                    });
                  } else {
                    this.tamanhoCalibreCount = 1;
                    let control = new FormControl('', []);
                    this.form.setControl('tamanho_calibre_0', control);
                    this.laudo['tamanho_calibre_0'] = '';
                  }
                } else {
                  this.tamanhoCalibreCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('tamanho_calibre_0', control);
                  this.laudo['tamanho_calibre_0'] = '';
                }
                this.atualizarTamanhoCalibreTriplets();

                if (this.laudo.data_fabricacao) {
                  let dfData = [];
                  try {
                    dfData = typeof this.laudo.data_fabricacao === 'string' && this.laudo.data_fabricacao.startsWith('[') ? JSON.parse(this.laudo.data_fabricacao) : (Array.isArray(this.laudo.data_fabricacao) ? this.laudo.data_fabricacao : [this.laudo.data_fabricacao]);
                  } catch(e) {
                    dfData = [this.laudo.data_fabricacao];
                  }
                  dfData = dfData.filter(v => v !== null && v !== undefined && v !== '');
                  if (dfData.length > 0) {
                    this.fabricacaoCount = dfData.length;
                    dfData.forEach((df, i) => {
                      let control = new FormControl(df, []);
                      this.form.setControl('data_fabricacao_' + i, control);
                      this.laudo['data_fabricacao_' + i] = df;
                    });
                  } else {
                    this.fabricacaoCount = 1;
                    let control = new FormControl('', []);
                    this.form.setControl('data_fabricacao_0', control);
                    this.laudo['data_fabricacao_0'] = '';
                  }
                } else {
                  this.fabricacaoCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('data_fabricacao_0', control);
                  this.laudo['data_fabricacao_0'] = '';
                }
                this.atualizarFabricacaoTriplets();

                if (this.laudo.data_validade) {
                  let dvData = [];
                  try {
                    dvData = typeof this.laudo.data_validade === 'string' && this.laudo.data_validade.startsWith('[') ? JSON.parse(this.laudo.data_validade) : (Array.isArray(this.laudo.data_validade) ? this.laudo.data_validade : [this.laudo.data_validade]);
                  } catch(e) {
                    dvData = [this.laudo.data_validade];
                  }
                  dvData = dvData.filter(v => v !== null && v !== undefined && v !== '');
                  if (dvData.length > 0) {
                    this.validadeCount = dvData.length;
                    dvData.forEach((dv, i) => {
                      let control = new FormControl(dv, []);
                      this.form.setControl('data_validade_' + i, control);
                      this.laudo['data_validade_' + i] = dv;
                    });
                  } else {
                    this.validadeCount = 1;
                    let control = new FormControl('', []);
                    this.form.setControl('data_validade_0', control);
                    this.laudo['data_validade_0'] = '';
                  }
                } else {
                  this.validadeCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('data_validade_0', control);
                  this.laudo['data_validade_0'] = '';
                }
                this.atualizarValidadeTriplets();

                this.carregarPesagem();
                this.rebuildCalibresControls();
              });
            } else {
              let laudoData: any = Object.assign({}, this.laudo);
              delete laudoData.fotos;
              this.form.patchValue(laudoData);

              if (this.laudo.stakeholders) {
                this.stakeholdersSelecionados = this.laudo.stakeholders.map(s => s.id);
              } else {
                this.stakeholdersSelecionados = [];
              }

              if (this.laudo.responsaveis_tecnicos) {
                this.responsaveisTecnicosSelecionados = this.laudo.responsaveis_tecnicos.map(rt => rt.id);
              } else {
                this.responsaveisTecnicosSelecionados = [];
              }

              if (this.laudo.observacoes) {
                this.observacoesSelecionadas = this.laudo.observacoes.map(obs => obs.id);
              } else {
                this.observacoesSelecionadas = [];
              }

              if (this.laudo.temperaturas_polpa) {
                let temps = typeof this.laudo.temperaturas_polpa === 'string' ? JSON.parse(this.laudo.temperaturas_polpa) : this.laudo.temperaturas_polpa;
                if (Array.isArray(temps) && temps.length > 0) {
                  let count = temps.length;
                  if (count < 3) count = 3;
                  if (count > 6) count = 6;
                  this.temperaturasCount = count;
                  temps.forEach((t, i) => {
                    if (i < 6) {
                      this.form.controls['temp_' + i].setValue(t);
                      this.laudo['temp_' + i] = t;
                    }
                  });
                  for (let i = temps.length; i < 3; i++) {
                    this.form.controls['temp_' + i].setValue('');
                    this.laudo['temp_' + i] = '';
                  }
                } else {
                  this.temperaturasCount = 3;
                  this.form.controls['temp_0'].setValue('');
                  this.form.controls['temp_1'].setValue('');
                  this.form.controls['temp_2'].setValue('');
                  this.laudo['temp_0'] = '';
                  this.laudo['temp_1'] = '';
                  this.laudo['temp_2'] = '';
                }
              } else {
                this.temperaturasCount = 3;
                this.form.controls['temp_0'].setValue('');
                this.form.controls['temp_1'].setValue('');
                this.form.controls['temp_2'].setValue('');
                this.laudo['temp_0'] = '';
                this.laudo['temp_1'] = '';
                this.laudo['temp_2'] = '';
              }

              this.atualizarTriplets();
              this.calcularMinMaxMedia();

              if (this.laudo.pressao_polpa) {
                let pressao = typeof this.laudo.pressao_polpa === 'string' ? JSON.parse(this.laudo.pressao_polpa) : this.laudo.pressao_polpa;
                if (Array.isArray(pressao) && pressao.length > 0) {
                  this.pressaoCount = pressao.length;
                  pressao.forEach((p, i) => {
                    let control = new FormControl(p, []);
                    this.form.setControl('pressao_' + i, control);
                    this.laudo['pressao_' + i] = p;
                  });
                } else {
                  this.pressaoCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('pressao_0', control);
                  this.laudo['pressao_0'] = '';
                }
              } else {
                this.pressaoCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('pressao_0', control);
                this.laudo['pressao_0'] = '';
              }
              this.atualizarPressaoTriplets();
              this.calcularMinMaxMediaPressao();

              if (this.laudo.brix) {
                let brixData = typeof this.laudo.brix === 'string' ? JSON.parse(this.laudo.brix) : this.laudo.brix;
                if (Array.isArray(brixData) && brixData.length > 0) {
                  this.brixCount = brixData.length;
                  brixData.forEach((b, i) => {
                    let control = new FormControl(b, []);
                    this.form.setControl('brix_' + i, control);
                    this.laudo['brix_' + i] = b;
                  });
                } else {
                  this.brixCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('brix_0', control);
                  this.laudo['brix_0'] = '';
                }
              } else {
                this.brixCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('brix_0', control);
                this.laudo['brix_0'] = '';
              }
              this.atualizarBrixTriplets();
              this.calcularMinMaxMediaBrix();

              if (this.laudo.tamanho_calibre) {
                let tcData = this.laudo.tamanho_calibre.split(',').map(v => v.trim()).filter(v => v !== '');
                if (tcData.length > 0) {
                  this.tamanhoCalibreCount = tcData.length;
                  tcData.forEach((tc, i) => {
                    let control = new FormControl(tc, []);
                    this.form.setControl('tamanho_calibre_' + i, control);
                    this.laudo['tamanho_calibre_' + i] = tc;
                  });
                } else {
                  this.tamanhoCalibreCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('tamanho_calibre_0', control);
                  this.laudo['tamanho_calibre_0'] = '';
                }
              } else {
                this.tamanhoCalibreCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('tamanho_calibre_0', control);
                this.laudo['tamanho_calibre_0'] = '';
              }
              this.atualizarTamanhoCalibreTriplets();

              if (this.laudo.data_fabricacao) {
                let dfData = [];
                try {
                  dfData = typeof this.laudo.data_fabricacao === 'string' && this.laudo.data_fabricacao.startsWith('[') ? JSON.parse(this.laudo.data_fabricacao) : (Array.isArray(this.laudo.data_fabricacao) ? this.laudo.data_fabricacao : [this.laudo.data_fabricacao]);
                } catch(e) {
                  dfData = [this.laudo.data_fabricacao];
                }
                dfData = dfData.filter(v => v !== null && v !== undefined && v !== '');
                if (dfData.length > 0) {
                  this.fabricacaoCount = dfData.length;
                  dfData.forEach((df, i) => {
                    let control = new FormControl(df, []);
                    this.form.setControl('data_fabricacao_' + i, control);
                    this.laudo['data_fabricacao_' + i] = df;
                  });
                } else {
                  this.fabricacaoCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('data_fabricacao_0', control);
                  this.laudo['data_fabricacao_0'] = '';
                }
              } else {
                this.fabricacaoCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('data_fabricacao_0', control);
                this.laudo['data_fabricacao_0'] = '';
              }
              this.atualizarFabricacaoTriplets();

              if (this.laudo.data_validade) {
                let dvData = [];
                try {
                  dvData = typeof this.laudo.data_validade === 'string' && this.laudo.data_validade.startsWith('[') ? JSON.parse(this.laudo.data_validade) : (Array.isArray(this.laudo.data_validade) ? this.laudo.data_validade : [this.laudo.data_validade]);
                } catch(e) {
                  dvData = [this.laudo.data_validade];
                }
                dvData = dvData.filter(v => v !== null && v !== undefined && v !== '');
                if (dvData.length > 0) {
                  this.validadeCount = dvData.length;
                  dvData.forEach((dv, i) => {
                    let control = new FormControl(dv, []);
                    this.form.setControl('data_validade_' + i, control);
                    this.laudo['data_validade_' + i] = dv;
                  });
                } else {
                  this.validadeCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('data_validade_0', control);
                  this.laudo['data_validade_0'] = '';
                }
              } else {
                this.validadeCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('data_validade_0', control);
                this.laudo['data_validade_0'] = '';
              }
              this.atualizarValidadeTriplets();

              this.carregarPesagem();
              this.rebuildCalibresControls();
            }

            this.atualizarEstivagem();

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  carregarListas() {
    this.clientesService.get().subscribe(res => this.listClientes = res.Payload);
    this.paisesService.get().subscribe(res => this.listPaises = res.Payload);
    this.transportadorasService.get().subscribe(res => this.listTransportadoras = res.Payload);
    this.tipoUnidadeService.get().subscribe(res => this.listTiposUnidade = res.Payload);
    this.tipoTransporteService.get().subscribe(res => this.listTiposTransporte = res.Payload);
    this.mercadoriasService.get().subscribe(res => this.listProdutos = res.Payload);
    this.mercadoriasEmbalagensService.get().subscribe(res => this.listEmbalagens = res.Payload);
    this.mercadoriasCategoriasService.get().subscribe(res => this.listCategorias = res.Payload);
    this.stakeholdersService.get().subscribe(res => this.listStakeholders = res.Payload);
    this.responsaveisTecnicosService.get().subscribe(res => {
      this.listResponsaveisTecnicos = res.Payload;

      const duplicateId = this.route.snapshot.queryParams['duplicate_id'];
      if (this.pageIsAdd && !duplicateId) {
        const selectedIds = [];
        const namesToSelect = ["FRANCISCO TURNES", "HAILTON AZEVEDO PELAES"];
        if (this.listResponsaveisTecnicos) {
          this.listResponsaveisTecnicos.forEach(rt => {
            const rtName = rt.nome ? rt.nome.trim().toUpperCase() : '';
            if (namesToSelect.indexOf(rtName) !== -1) {
              selectedIds.push(rt.id);
            }
          });
        }
        this.responsaveisTecnicosSelecionados = selectedIds;
      }
    });
    this.observacoesService.get().subscribe(res => this.listObservacoes = res.Payload);
    this.labelFotosService.get(['mercadorias']).subscribe(res => this.listLabelsFotos = res.Payload);
    this.unidadesService.get().subscribe(res => this.listUnidades = res.Payload);
    this.unidadesMedidasService.get().subscribe(json => {
      this.listTodasUnidadesMedidas = json.Payload;
      this.listUnidadesMedidas = json.Payload.filter(item => item.nome === 'CBM' || item.nome === 'CMH' || item.nome === 'PORCENTAGEM');
    });
    this.coloracaoService.get().subscribe(res => this.listColoracoes = res.Payload);

    this.exportadoresService.get().subscribe(res => this.listExportadores = res.Payload);
    this.terminaisService.get().subscribe(res => this.listTerminal = res.Payload);
    this.armadoresService.get().subscribe(res => this.listArmador = res.Payload);
    this.locaisService.get().subscribe(res => this.listLocais = res.Payload);

    // traduz labels do shelf life
    this.listShelfLifeLabels.forEach(item => {
      item.nome = this.func.traduzir('front.' + item.id);
    });
  }

  changeMercadoria(e, reset = true, duplicateIndices = null) {
    if (e && e !== 'null' && e !== 'undefined' && e !== '') {
      this.mercadoriasService.getById(e, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"]).subscribe(json => {
        this.mercadoriaConfig = json.Payload[0];
        this.listVariedades = json.Payload[0].variedades || [];
        this.listIndicesClassificacao = json.Payload[0].indices_classificacao || [];
        this.listIndicesConclusao = json.Payload[0].indices_conclusao || [];

        // Limpa controles ODR e Indices antigos do FormGroup antes de registrar novos
        Object.keys(this.form.controls).forEach(key => {
          if (key.startsWith('odr_input_') || key.startsWith('indiceConclusao')) {
            this.form.removeControl(key);
          }
        });

        // Registrar os novos controles de índice de conclusão
        this.indicesConclusaoSelecionados = [];
        this.modelIndicesConclusaoSelecionados = [];

        const indicesToMatch = reset ? null : (duplicateIndices || this.laudo.indices_conclusao);

        this.listIndicesConclusao.forEach((jIndice, j) => {
          let control = new FormControl('indiceConclusao' + j, [Validators.required]);
          this.form.setControl('indiceConclusao' + j, control);

          let matched = false;
          if (indicesToMatch) {
            for (let k in jIndice.itens) {
              for (let q in indicesToMatch) {
                if (jIndice.nome_pt == indicesToMatch[q].nome_pt) {
                  if (jIndice.itens[k].nome_pt == indicesToMatch[q].valor.nome_pt) {
                    this.modelIndicesConclusaoSelecionados.push(k);
                    matched = true;
                    this.indicesConclusaoSelecionados.push({
                      "nome_pt": jIndice.nome_pt,
                      "nome_en": jIndice.nome_en,
                      "nome_es": jIndice.nome_es,
                      "valor": {
                        "nome_pt": jIndice.itens[k].nome_pt,
                        "nome_en": jIndice.itens[k].nome_en,
                        "nome_es": jIndice.itens[k].nome_es
                      }
                    });
                    break;
                  }
                }
              }
              if (matched) break;
            }
          }

          if (!matched) {
            this.modelIndicesConclusaoSelecionados.push(null);
            this.indicesConclusaoSelecionados.push({
              "nome_pt": jIndice.nome_pt,
              "nome_en": jIndice.nome_en,
              "nome_es": jIndice.nome_es,
              "valor": {
                "nome_pt": null,
                "nome_en": null,
                "nome_es": null
              }
            });
          }
        });

        const mProd = json.Payload[0];
        this.formula_odr = mProd.formula_odr;
        this.odr_inputs_config = mProd.odr_inputs_config || [];
        this.odr_valores = {};
        this.odr_inputs_config.forEach(input => {
          this.odr_valores[input.chave] = 0;
          let control = new FormControl('odr_input_' + input.chave, []);
          this.form.setControl('odr_input_' + input.chave, control);
        });

        this.listDefeitos = [];
        if (json.Payload[0].defeitos) {
          for (let x in json.Payload[0].defeitos) {
            let control = new FormControl('defeito' + x, []);
            this.form.setControl('defeito' + x, control);
            let control2 = new FormControl('defeitoAtivo' + x, []);
            this.form.setControl('defeitoAtivo' + x, control2);

            let valor = 0.00;
            let ativo = true;

            this.listDefeitos.push({
              "id_defeito": json.Payload[0].defeitos[x].id,
              "nome_pt": json.Payload[0].defeitos[x].nome_pt,
              "valor": valor,
              "ativo": ativo,
              "is_indice_acumulado": json.Payload[0].defeitos[x].is_indice_acumulado,
              "indices_acumulados": json.Payload[0].defeitos[x].indices_acumulados,
              "ordem": json.Payload[0].defeitos[x].ordem
            });
          }
        }
        this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
        this.calcularODR();

        if (reset) {
          this.laudo.id_variedade = null;
          this.form.controls['id_variedade'].setValue(null);

          // 1. Reset all photos labels to null ("SEM LABEL")
          if (this.listFotos) {
            this.listFotos.forEach(f => {
              f.id_label_foto = null;
              f.id_defeito = null;
              f._categoria_id = null;
            });
          }

          // 2. Clear and populate labelsSelecionados, labelsDefeitosSelecionados, and categories order
          this.labelsSelecionados = [];
          this.labelsDefeitosSelecionados = [];
          this.ordemCategorias = [];

          if (this.listLabelsFotos) {
            const matchingLabels = this.listLabelsFotos.filter(lbl => 
              lbl.mercadorias && lbl.mercadorias.some(m => String(m.id) === String(e))
            );
            this.labelsSelecionados = matchingLabels.map(lbl => lbl.id);
            matchingLabels.forEach(lbl => {
              this.ordemCategorias.push('label:' + lbl.id);
            });
          }

          if (this.listDefeitos) {
            this.labelsDefeitosSelecionados = this.listDefeitos.map(def => def.id_defeito);
            this.listDefeitos.forEach(def => {
              this.ordemCategorias.push('defeito:' + def.id_defeito);
            });
          }
        }
        this.rebuildCalibresControls();
        if (this.pesagens) {
          this.pesagens.forEach((_, pIdx) => {
            const ctrl = this.form.controls[`pesagem_${pIdx}_peso_liquido`];
            if (ctrl) {
              ctrl.updateValueAndValidity();
            }
          });
        }
      });
    } else {
      this.mercadoriaConfig = null;
      // Limpa controles ODR e Indices antigos se não houver mercadoria selecionada
      Object.keys(this.form.controls).forEach(key => {
        if (key.startsWith('odr_input_') || key.startsWith('indiceConclusao')) {
          this.form.removeControl(key);
        }
      });

      this.listVariedades = [];
      this.listDefeitos = [];
      this.listIndicesClassificacao = [];
      this.listIndicesClassificacaoCalculado = [];
      this.listIndicesConclusao = [];
      this.indicesConclusaoSelecionados = [];
      this.modelIndicesConclusaoSelecionados = [];
      this.formula_odr = null;
      this.odr_inputs_config = [];
      this.odr_valores = {};
      this.odr_calculado = null;
      if (reset) {
        this.laudo.id_variedade = null;
        this.form.controls['id_variedade'].setValue(null);

        if (this.listFotos) {
          this.listFotos.forEach(f => {
            f.id_label_foto = null;
            f.id_defeito = null;
            f._categoria_id = null;
          });
        }
        this.labelsSelecionados = [];
        this.labelsDefeitosSelecionados = [];
        this.ordemCategorias = [];
      }
      if (this.pesagens) {
        this.pesagens.forEach((_, pIdx) => {
          const ctrl = this.form.controls[`pesagem_${pIdx}_peso_liquido`];
          if (ctrl) {
            ctrl.updateValueAndValidity();
          }
        });
      }
    }
  }

  updateIndiceConclusao(i, event) {
    if (event.target.value == null || event.target.value == 'null') {
      this.indicesConclusaoSelecionados[i] = {
        "nome_pt": this.listIndicesConclusao[i].nome_pt,
        "nome_en": this.listIndicesConclusao[i].nome_en,
        "nome_es": this.listIndicesConclusao[i].nome_es,
        "valor": {
          "nome_pt": null,
          "nome_en": null,
          "nome_es": null
        }
      };
    } else {
      this.indicesConclusaoSelecionados[i] = {
        "nome_pt": this.listIndicesConclusao[i].nome_pt,
        "nome_en": this.listIndicesConclusao[i].nome_en,
        "nome_es": this.listIndicesConclusao[i].nome_es,
        "valor": {
          "nome_pt": this.listIndicesConclusao[i].itens[event.target.value].nome_pt,
          "nome_en": this.listIndicesConclusao[i].itens[event.target.value].nome_en,
          "nome_es": this.listIndicesConclusao[i].itens[event.target.value].nome_es
        }
      };
    }
  }

  addStakeholder() {
    let totalDisponivel = this.listStakeholders ? this.listStakeholders.length : 0;
    if (this.stakeholdersSelecionados.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.todosStakeholdersJaAdicionados'), 'erro');
      return;
    }
    this.stakeholdersSelecionados.push(null);
  }

  removeStakeholder(i) {
    this.stakeholdersSelecionados.splice(i, 1);
  }

  getStakeholdersDisponiveis(indexAtual: number) {
    if (!this.listStakeholders) return [];
    return this.listStakeholders.filter(stk => {
      let findIdx = this.stakeholdersSelecionados.findIndex(id => id != null && String(id) === String(stk.id));
      return findIdx === -1 || findIdx === indexAtual;
    });
  }

  getStkFuncao(stk: any) {
    const lang = this.translateService.currentLang || 'pt';
    return stk['funcao_' + lang] || stk.funcao_pt || stk.funcao;
  }

  addResponsavelTecnico() {
    let totalDisponivel = this.listResponsaveisTecnicos ? this.listResponsaveisTecnicos.length : 0;
    if (this.responsaveisTecnicosSelecionados.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.todosResponsaveisTecnicosJaAdicionados'), 'erro');
      return;
    }
    this.responsaveisTecnicosSelecionados.push(null);
  }

  removeResponsavelTecnico(i) {
    this.responsaveisTecnicosSelecionados.splice(i, 1);
  }

  getResponsaveisTecnicosDisponiveis(indexAtual: number) {
    if (!this.listResponsaveisTecnicos) return [];
    return this.listResponsaveisTecnicos.filter(rt => {
      let findIdx = this.responsaveisTecnicosSelecionados.findIndex(id => id != null && String(id) === String(rt.id));
      return findIdx === -1 || findIdx === indexAtual;
    });
  }

  getRtCargo(rt: any) {
    const lang = this.translateService.currentLang || 'pt';
    return rt['cargo_' + lang] || rt.cargo_pt || rt.cargo;
  }

  addObservacao() {
    let totalDisponivel = this.listObservacoes ? this.listObservacoes.length : 0;
    if (this.observacoesSelecionadas.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.todasObservacoesJaAdicionadas'), 'erro');
      return;
    }
    this.observacoesSelecionadas.push(null);
  }

  removeObservacao(i) {
    this.observacoesSelecionadas.splice(i, 1);
  }

  formatOptionText(texto: string, maxLen: number = 110): string {
    if (!texto) return '';
    const clean = texto.trim().replace(/\s+/g, ' ');
    return clean.length > maxLen ? clean.substring(0, maxLen) + '...' : clean;
  }

  getObservacaoTexto(id: any): string {
    if (!id || !this.listObservacoes) return '';
    const item = this.listObservacoes.find(o => o.id == id);
    return item ? (item.observacao_pt || item.observacao_en || item.observacao_es || '') : '';
  }

  getObservacoesDisponiveis(indexAtual: number) {
    if (!this.listObservacoes) return [];
    return this.listObservacoes.filter(obs => {
      let findIdx = this.observacoesSelecionadas.findIndex(id => id != null && String(id) === String(obs.id));
      return findIdx === -1 || findIdx === indexAtual;
    });
  }

  atualizarTriplets() {
    let triplets = [];
    for (let i = 0; i < this.temperaturasCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.temperaturasCount) trip.push(i + 1);
      if (i + 2 < this.temperaturasCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.temperaturasTriplets = triplets;
  }

  addTemperatura() {
    if (this.temperaturasCount < 6) {
      let nextIdx = this.temperaturasCount;
      this.form.controls['temp_' + nextIdx].setValue('');
      this.laudo['temp_' + nextIdx] = '';
      this.temperaturasCount++;
      this.atualizarTriplets();
      this.calcularMinMaxMedia();
      
      setTimeout(() => {
        let el = document.getElementById('temp_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeTemperatura(idx: number) {
    if (this.temperaturasCount > 3) {
      for (let i = idx; i < this.temperaturasCount - 1; i++) {
        let nextVal = this.form.controls['temp_' + (i + 1)].value;
        this.form.controls['temp_' + i].setValue(nextVal);
        this.laudo['temp_' + i] = nextVal;
      }
      let lastIdx = this.temperaturasCount - 1;
      this.form.controls['temp_' + lastIdx].setValue('');
      this.laudo['temp_' + lastIdx] = '';
      
      this.temperaturasCount--;
      this.atualizarTriplets();
      this.calcularMinMaxMedia();
    }
  }

  calcularMinMaxMedia() {
    let validValues = [];
    for (let i = 0; i < this.temperaturasCount; i++) {
      let val = this.form.controls['temp_' + i].value;
      if (val !== null && val !== undefined && val !== '') {
        let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
        if (!isNaN(valFloat) && isFinite(valFloat)) {
          validValues.push(valFloat);
        }
      }
    }

    if (validValues.length > 0) {
      this.tempMin = Math.min(...validValues);
      this.tempMax = Math.max(...validValues);
      let sum = validValues.reduce((a, b) => a + b, 0);
      this.tempMedia = sum / validValues.length;
    } else {
      this.tempMin = null;
      this.tempMax = null;
      this.tempMedia = null;
    }
  }

  atualizarPressaoTriplets() {
    let triplets = [];
    for (let i = 0; i < this.pressaoCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.pressaoCount) trip.push(i + 1);
      if (i + 2 < this.pressaoCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.pressaoTriplets = triplets;
  }

  addPressao() {
    if (this.pressaoCount < 60) {
      let nextIdx = this.pressaoCount;
      let control = new FormControl('', []);
      this.form.setControl('pressao_' + nextIdx, control);
      this.laudo['pressao_' + nextIdx] = '';
      this.pressaoCount++;
      this.atualizarPressaoTriplets();
      this.calcularMinMaxMediaPressao();
      
      setTimeout(() => {
        let el = document.getElementById('pressao_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removePressao(idx: number) {
    if (this.pressaoCount > 1) {
      for (let i = idx; i < this.pressaoCount - 1; i++) {
        let nextVal = this.form.controls['pressao_' + (i + 1)].value;
        this.form.controls['pressao_' + i].setValue(nextVal);
        this.laudo['pressao_' + i] = nextVal;
      }
      let lastIdx = this.pressaoCount - 1;
      this.form.removeControl('pressao_' + lastIdx);
      delete this.laudo['pressao_' + lastIdx];
      
      this.pressaoCount--;
      this.atualizarPressaoTriplets();
      this.calcularMinMaxMediaPressao();
    }
  }

  calcularMinMaxMediaPressao() {
    let validValues = [];
    for (let i = 0; i < this.pressaoCount; i++) {
      let control = this.form.controls['pressao_' + i];
      if (control) {
        let val = control.value;
        if (val !== null && val !== undefined && val !== '') {
          let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
          if (!isNaN(valFloat) && isFinite(valFloat)) {
            validValues.push(valFloat);
          }
        }
      }
    }

    if (validValues.length > 0) {
      this.pressaoMin = Math.min(...validValues);
      this.pressaoMax = Math.max(...validValues);
      let sum = validValues.reduce((a, b) => a + b, 0);
      this.pressaoMedia = sum / validValues.length;
    } else {
      this.pressaoMin = null;
      this.pressaoMax = null;
      this.pressaoMedia = null;
    }
  }

  atualizarBrixTriplets() {
    let triplets = [];
    for (let i = 0; i < this.brixCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.brixCount) trip.push(i + 1);
      if (i + 2 < this.brixCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.brixTriplets = triplets;
  }

  addBrix() {
    if (this.brixCount < 20) {
      let nextIdx = this.brixCount;
      let control = new FormControl('', []);
      this.form.setControl('brix_' + nextIdx, control);
      this.laudo['brix_' + nextIdx] = '';
      this.brixCount++;
      this.atualizarBrixTriplets();
      this.calcularMinMaxMediaBrix();
      
      setTimeout(() => {
        let el = document.getElementById('brix_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeBrix(idx: number) {
    if (this.brixCount > 1) {
      for (let i = idx; i < this.brixCount - 1; i++) {
        let nextVal = this.form.controls['brix_' + (i + 1)].value;
        this.form.controls['brix_' + i].setValue(nextVal);
        this.laudo['brix_' + i] = nextVal;
      }
      let lastIdx = this.brixCount - 1;
      this.form.removeControl('brix_' + lastIdx);
      delete this.laudo['brix_' + lastIdx];
      
      this.brixCount--;
      this.atualizarBrixTriplets();
      this.calcularMinMaxMediaBrix();
    }
  }

  calcularMinMaxMediaBrix() {
    let validValues = [];
    for (let i = 0; i < this.brixCount; i++) {
      let control = this.form.controls['brix_' + i];
      if (control) {
        let val = control.value;
        if (val !== null && val !== undefined && val !== '') {
          let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
          if (!isNaN(valFloat) && isFinite(valFloat)) {
            validValues.push(valFloat);
          }
        }
      }
    }

    if (validValues.length > 0) {
      this.brixMin = Math.min(...validValues);
      this.brixMax = Math.max(...validValues);
      let sum = validValues.reduce((a, b) => a + b, 0);
      this.brixMedia = sum / validValues.length;
    } else {
      this.brixMin = null;
      this.brixMax = null;
      this.brixMedia = null;
    }
  }

  atualizarTamanhoCalibreTriplets() {
    let triplets = [];
    for (let i = 0; i < this.tamanhoCalibreCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.tamanhoCalibreCount) trip.push(i + 1);
      if (i + 2 < this.tamanhoCalibreCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.tamanhoCalibreTriplets = triplets;
  }

  addTamanhoCalibre() {
    if (this.tamanhoCalibreCount < 20) {
      let nextIdx = this.tamanhoCalibreCount;
      let control = new FormControl('', []);
      this.form.setControl('tamanho_calibre_' + nextIdx, control);
      this.laudo['tamanho_calibre_' + nextIdx] = '';
      this.tamanhoCalibreCount++;
      this.atualizarTamanhoCalibreTriplets();

      // Sincroniza com calibres!
      if (this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_calibre_multiplo === true) {
        if (!this.laudo.calibres) {
          this.laudo.calibres = [];
        }
        this.laudo.calibres.push(this.criarNovoItemCalibre());
        this.rebuildCalibresControls();
      }
      
      setTimeout(() => {
        let el = document.getElementById('tamanho_calibre_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeTamanhoCalibre(idx: number) {
    if (this.tamanhoCalibreCount > 1) {
      for (let i = idx; i < this.tamanhoCalibreCount - 1; i++) {
        let nextVal = this.form.controls['tamanho_calibre_' + (i + 1)].value;
        this.form.controls['tamanho_calibre_' + i].setValue(nextVal);
        this.laudo['tamanho_calibre_' + i] = nextVal;
      }
      let lastIdx = this.tamanhoCalibreCount - 1;
      this.form.removeControl('tamanho_calibre_' + lastIdx);
      delete this.laudo['tamanho_calibre_' + lastIdx];
      
      this.tamanhoCalibreCount--;
      this.atualizarTamanhoCalibreTriplets();

      // Sincroniza com calibres!
      if (this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_calibre_multiplo === true) {
        if (this.laudo.calibres && this.laudo.calibres.length > idx) {
          this.laudo.calibres.splice(idx, 1);
          this.rebuildCalibresControls();
        }
      }
    }
  }

  atualizarFabricacaoTriplets() {
    let triplets = [];
    for (let i = 0; i < this.fabricacaoCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.fabricacaoCount) trip.push(i + 1);
      if (i + 2 < this.fabricacaoCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.fabricacaoTriplets = triplets;
  }

  addFabricacao() {
    if (this.fabricacaoCount < 20) {
      let nextIdx = this.fabricacaoCount;
      let control = new FormControl('', []);
      this.form.setControl('data_fabricacao_' + nextIdx, control);
      this.laudo['data_fabricacao_' + nextIdx] = '';
      this.fabricacaoCount++;
      this.atualizarFabricacaoTriplets();

      setTimeout(() => {
        let el = document.getElementById('data_fabricacao_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeFabricacao(idx: number) {
    if (this.fabricacaoCount > 1) {
      for (let i = idx; i < this.fabricacaoCount - 1; i++) {
        let nextVal = this.form.controls['data_fabricacao_' + (i + 1)].value;
        this.form.controls['data_fabricacao_' + i].setValue(nextVal);
        this.laudo['data_fabricacao_' + i] = nextVal;
      }
      let lastIdx = this.fabricacaoCount - 1;
      this.form.removeControl('data_fabricacao_' + lastIdx);
      delete this.laudo['data_fabricacao_' + lastIdx];

      this.fabricacaoCount--;
      this.atualizarFabricacaoTriplets();
    }
  }

  atualizarValidadeTriplets() {
    let triplets = [];
    for (let i = 0; i < this.validadeCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.validadeCount) trip.push(i + 1);
      if (i + 2 < this.validadeCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.validadeTriplets = triplets;
  }

  addValidade() {
    if (this.validadeCount < 20) {
      let nextIdx = this.validadeCount;
      let control = new FormControl('', []);
      this.form.setControl('data_validade_' + nextIdx, control);
      this.laudo['data_validade_' + nextIdx] = '';
      this.validadeCount++;
      this.atualizarValidadeTriplets();

      setTimeout(() => {
        let el = document.getElementById('data_validade_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeValidade(idx: number) {
    if (this.validadeCount > 1) {
      for (let i = idx; i < this.validadeCount - 1; i++) {
        let nextVal = this.form.controls['data_validade_' + (i + 1)].value;
        this.form.controls['data_validade_' + i].setValue(nextVal);
        this.laudo['data_validade_' + i] = nextVal;
      }
      let lastIdx = this.validadeCount - 1;
      this.form.removeControl('data_validade_' + lastIdx);
      delete this.laudo['data_validade_' + lastIdx];

      this.validadeCount--;
      this.atualizarValidadeTriplets();
    }
  }

  registrarControlesTermografo(i: number, tg: any) {
    if (tg && tg.id) {
      this.form.setControl('termografo_foto_' + tg.id + '_1', new FormControl('', []));
      this.form.setControl('termografo_foto_' + tg.id + '_2', new FormControl('', []));
      this.form.setControl('termografo_foto_' + tg.id + '_3', new FormControl('', []));
      this.form.setControl('termografo_foto_' + tg.id + '_4', new FormControl('', []));
    }
    this.form.setControl('termografo_' + i + '_inicializado', new FormControl(tg.inicializado !== false, []));
    this.form.setControl('termografo_' + i + '_encontrado', new FormControl(tg.encontrado !== false, []));
    this.form.setControl('termografo_' + i + '_sem_dados_restritos', new FormControl(tg.sem_dados_restritos !== false, []));
    this.form.setControl('termografo_' + i + '_numero', new FormControl(tg.numero || '', []));
    this.form.setControl('termografo_' + i + '_temperatura_minima', new FormControl(tg.temperatura_minima || '', []));
    this.form.setControl('termografo_' + i + '_temperatura_maxima', new FormControl(tg.temperatura_maxima || '', []));
    this.form.setControl('termografo_' + i + '_temperatura_media', new FormControl(tg.temperatura_media || '', []));
    if (tg.excesso_transit_time || tg.com_defeito || tg.fora_alcance || tg.fora_tolerancia) {
      tg.status = false;
    }
    this.form.setControl('termografo_' + i + '_status', new FormControl(tg.status !== false, []));
    this.form.setControl('termografo_' + i + '_excesso_transit_time', new FormControl(tg.excesso_transit_time || false, []));
    this.form.setControl('termografo_' + i + '_fora_alcance', new FormControl(tg.fora_alcance || false, []));
    this.form.setControl('termografo_' + i + '_com_defeito', new FormControl(tg.com_defeito || false, []));
    this.form.setControl('termografo_' + i + '_fora_tolerancia', new FormControl(tg.fora_tolerancia || false, []));
    this.prevTermografosState[i] = {
      inicializado: tg.inicializado !== false,
      encontrado: tg.encontrado !== false,
      sem_dados_restritos: tg.sem_dados_restritos !== false
    };
  }

  verificarStatusTermografo(i: number) {
    const tg = this.laudo.termografos[i];
    if (tg && (tg.excesso_transit_time || tg.com_defeito || tg.fora_alcance || tg.fora_tolerancia)) {
      tg.status = false;
      if (this.form.controls['termografo_' + i + '_status']) {
        this.form.controls['termografo_' + i + '_status'].setValue(false);
      }
    }
  }

  removerControlesTermografo(i: number) {
    let tg = this.laudo.termografos[i];
    if (tg && tg.id) {
      this.form.removeControl('termografo_foto_' + tg.id + '_1');
      this.form.removeControl('termografo_foto_' + tg.id + '_2');
      this.form.removeControl('termografo_foto_' + tg.id + '_3');
      this.form.removeControl('termografo_foto_' + tg.id + '_4');
    }
    this.form.removeControl('termografo_' + i + '_inicializado');
    this.form.removeControl('termografo_' + i + '_encontrado');
    this.form.removeControl('termografo_' + i + '_sem_dados_restritos');
    this.form.removeControl('termografo_' + i + '_numero');
    this.form.removeControl('termografo_' + i + '_temperatura_minima');
    this.form.removeControl('termografo_' + i + '_temperatura_maxima');
    this.form.removeControl('termografo_' + i + '_temperatura_media');
    this.form.removeControl('termografo_' + i + '_status');
    this.form.removeControl('termografo_' + i + '_excesso_transit_time');
    this.form.removeControl('termografo_' + i + '_fora_alcance');
    this.form.removeControl('termografo_' + i + '_com_defeito');
    this.form.removeControl('termografo_' + i + '_fora_tolerancia');
  }

  syncTermografosFromForm() {
    if (this.laudo.termografos) {
      this.laudo.termografos.forEach((tg, i) => {
        if (this.form.controls['termografo_' + i + '_inicializado']) {
          tg.inicializado = this.form.controls['termografo_' + i + '_inicializado'].value;
        }
        if (this.form.controls['termografo_' + i + '_encontrado']) {
          tg.encontrado = this.form.controls['termografo_' + i + '_encontrado'].value;
        }
        if (this.form.controls['termografo_' + i + '_sem_dados_restritos']) {
          tg.sem_dados_restritos = this.form.controls['termografo_' + i + '_sem_dados_restritos'].value;
        }
        if (this.form.controls['termografo_' + i + '_numero']) {
          tg.numero = this.form.controls['termografo_' + i + '_numero'].value;
        }
        if (this.form.controls['termografo_' + i + '_temperatura_minima']) {
          tg.temperatura_minima = this.form.controls['termografo_' + i + '_temperatura_minima'].value;
        }
        if (this.form.controls['termografo_' + i + '_temperatura_maxima']) {
          tg.temperatura_maxima = this.form.controls['termografo_' + i + '_temperatura_maxima'].value;
        }
        if (this.form.controls['termografo_' + i + '_temperatura_media']) {
          tg.temperatura_media = this.form.controls['termografo_' + i + '_temperatura_media'].value;
        }
        if (this.form.controls['termografo_' + i + '_status']) {
          tg.status = this.form.controls['termografo_' + i + '_status'].value;
        }
        if (this.form.controls['termografo_' + i + '_excesso_transit_time']) {
          tg.excesso_transit_time = this.form.controls['termografo_' + i + '_excesso_transit_time'].value;
        }
        if (this.form.controls['termografo_' + i + '_fora_alcance']) {
          tg.fora_alcance = this.form.controls['termografo_' + i + '_fora_alcance'].value;
        }
        if (this.form.controls['termografo_' + i + '_com_defeito']) {
          tg.com_defeito = this.form.controls['termografo_' + i + '_com_defeito'].value;
        }
        if (this.form.controls['termografo_' + i + '_fora_tolerancia']) {
          tg.fora_tolerancia = this.form.controls['termografo_' + i + '_fora_tolerancia'].value;
        }
      });
    }
  }

  addTermografo() {
    if (!this.laudo.termografos) {
      this.laudo.termografos = [];
    }
    const nextIdx = this.laudo.termografos.length;
    const newTg = {
      id: 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000),
      inicializado: true,
      encontrado: true,
      sem_dados_restritos: true,
      numero: '',
      temperatura_minima: '',
      temperatura_maxima: '',
      temperatura_media: '',
      status: true,
      excesso_transit_time: false,
      fora_alcance: false,
      com_defeito: false,
      fora_tolerancia: false,
      has_foto: false
    };
    this.laudo.termografos.push(newTg);
    this.registrarControlesTermografo(nextIdx, newTg);

    setTimeout(() => {
      let el = document.getElementById('termografo_' + nextIdx + '_numero');
      if (el) {
        el.focus();
      }
    }, 50);
  }

  removeTermografo(idx: number) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: "Deseja realmente remover este termógrafo?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.syncTermografosFromForm();
        
        // Remove all controls from form
        self.laudo.termografos.forEach((_, i) => {
          self.removerControlesTermografo(i);
        });

        self.laudo.termografos.splice(idx, 1);

        // Re-register controls
        self.laudo.termografos.forEach((tg, i) => {
          self.registrarControlesTermografo(i, tg);
        });
      });
  }

  abrirModalImportarTermografo(tipo: string = 'laudos-tecnicos') {
    this.importSourceType = tipo;
    this.numeroLaudoImportar = '';
    this.laudoEncontradoParaImportacao = null;
    this.buscandoLaudoImportar = false;
    this.mensagemErroImportacao = '';
    $('#modalImportarTermografo').modal('show');
  }

  buscarLaudoPorNumero() {
    if (!this.numeroLaudoImportar) {
      return;
    }
    this.buscandoLaudoImportar = true;
    this.mensagemErroImportacao = '';
    this.laudoEncontradoParaImportacao = null;

    this.laudosService.buscarTermografosPorNumero(this.importSourceType, this.numeroLaudoImportar)
      .subscribe(
        json => {
          this.buscandoLaudoImportar = false;
          if (json.Success && json.Payload && json.Payload.length > 0) {
            const l = json.Payload[0];
            if (typeof l.termografos === 'string') {
              l.termografos = JSON.parse(l.termografos);
            }
            if (l.termografos && l.termografos.length > 0) {
              this.laudoEncontradoParaImportacao = l;
            } else {
              this.mensagemErroImportacao = this.func.traduzir('front.nenhumTermografoCadastrado');
            }
          } else {
            this.mensagemErroImportacao = this.func.traduzir('front.nenhumLaudoEncontradoNumero');
          }
        },
        err => {
          this.buscandoLaudoImportar = false;
          this.mensagemErroImportacao = this.func.traduzir('front.erroImportarTermografo');
        }
      );
  }

  confirmarImportacaoTermografo(tgSelecionado: any) {
    if (!this.laudoEncontradoParaImportacao || !tgSelecionado) {
      return;
    }
    let sourceId = '';
    if (this.importSourceType === 'fichas') {
      sourceId = this.laudoEncontradoParaImportacao.id_ficha;
    } else if (this.importSourceType === 'laudos-cd') {
      sourceId = this.laudoEncontradoParaImportacao.id_laudo_cd;
    } else if (this.importSourceType === 'laudos-tecnicos') {
      sourceId = this.laudoEncontradoParaImportacao.id_laudo_tecnico;
    }

    const targetTgId = 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000);
    this.laudosService.importarTermografo(this.laudo.id_laudo_tecnico, sourceId, tgSelecionado.id, targetTgId, this.importSourceType)
      .subscribe(
        json => {
          if (json.Success) {
            this.syncTermografosFromForm();

            // Remove todos os controles anteriores do form
            this.laudo.termografos.forEach((_, i) => {
              this.removerControlesTermografo(i);
            });

            // Cria o novo objeto do termografo importado
            const novoTg = {
              id: targetTgId,
              inicializado: tgSelecionado.inicializado || false,
              encontrado: tgSelecionado.encontrado !== false,
              sem_dados_restritos: tgSelecionado.sem_dados_restritos !== false,
              numero: tgSelecionado.numero || '',
              temperatura_minima: tgSelecionado.temperatura_minima || '',
              temperatura_maxima: tgSelecionado.temperatura_maxima || '',
              temperatura_media: tgSelecionado.temperatura_media || '',
              status: tgSelecionado.status !== false,
              excesso_transit_time: tgSelecionado.excesso_transit_time || false,
              fora_alcance: tgSelecionado.fora_alcance || false,
              com_defeito: tgSelecionado.com_defeito || false,
              fora_tolerancia: tgSelecionado.fora_tolerancia || false,
              has_foto: tgSelecionado.has_foto || false,
              has_foto_2: tgSelecionado.has_foto_2 || false,
              has_foto_3: tgSelecionado.has_foto_3 || false,
              has_foto_4: tgSelecionado.has_foto_4 || false
            };

            this.laudo.termografos.push(novoTg);

            // Re-registra todos os controles no form
            this.laudo.termografos.forEach((tg, i) => {
              this.registrarControlesTermografo(i, tg);
            });

            $('#modalImportarTermografo').modal('hide');
            swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.termografoImportadoSucesso'), "success");
          } else {
            swal(this.func.traduzir('front.erro'), this.func.traduzir('front.erroImportarTermografo'), "error");
          }
        },
        err => {
          swal(this.func.traduzir('front.erro'), this.func.traduzir('front.erroImportarTermografo'), "error");
        }
      );
  }

  changeTermografoCaracteristicas(i) {
    const tg = this.laudo.termografos[i];
    const prev = this.prevTermografosState[i] || { inicializado: true, encontrado: true, sem_dados_restritos: true };

    const inicializado = tg.inicializado !== false;
    const encontrado = tg.encontrado !== false;
    const semDadosRestritos = tg.sem_dados_restritos !== false;

    const inicializadoChangedToFalse = (!inicializado && prev.inicializado);
    const encontradoChangedToFalse = (!encontrado && prev.encontrado);
    const semDadosRestritosChangedToFalse = (!semDadosRestritos && prev.sem_dados_restritos);

    if (inicializadoChangedToFalse) {
      tg.encontrado = true;
      if (this.form.controls['termografo_' + i + '_encontrado']) {
        this.form.controls['termografo_' + i + '_encontrado'].setValue(true);
      }
      tg.sem_dados_restritos = true;
      if (this.form.controls['termografo_' + i + '_sem_dados_restritos']) {
        this.form.controls['termografo_' + i + '_sem_dados_restritos'].setValue(true);
      }
    } else if (encontradoChangedToFalse) {
      tg.inicializado = true;
      if (this.form.controls['termografo_' + i + '_inicializado']) {
        this.form.controls['termografo_' + i + '_inicializado'].setValue(true);
      }
      tg.sem_dados_restritos = true;
      if (this.form.controls['termografo_' + i + '_sem_dados_restritos']) {
        this.form.controls['termografo_' + i + '_sem_dados_restritos'].setValue(true);
      }
    } else if (semDadosRestritosChangedToFalse) {
      tg.inicializado = true;
      if (this.form.controls['termografo_' + i + '_inicializado']) {
        this.form.controls['termografo_' + i + '_inicializado'].setValue(true);
      }
      tg.encontrado = true;
      if (this.form.controls['termografo_' + i + '_encontrado']) {
        this.form.controls['termografo_' + i + '_encontrado'].setValue(true);
      }
    }

    this.prevTermografosState[i] = {
      inicializado: tg.inicializado !== false,
      encontrado: tg.encontrado !== false,
      sem_dados_restritos: tg.sem_dados_restritos !== false
    };

    if (!tg.inicializado || tg.encontrado === false || tg.sem_dados_restritos === false) {
      if (!tg.inicializado) {
        if (this.form.controls['termografo_' + i + '_temperatura_minima']) {
          this.form.controls['termografo_' + i + '_temperatura_minima'].setValue('');
        }
        if (this.form.controls['termografo_' + i + '_temperatura_media']) {
          this.form.controls['termografo_' + i + '_temperatura_media'].setValue('');
        }
        if (this.form.controls['termografo_' + i + '_temperatura_maxima']) {
          this.form.controls['termografo_' + i + '_temperatura_maxima'].setValue('');
        }
      }
      if (this.form.controls['termografo_' + i + '_status']) {
        this.form.controls['termografo_' + i + '_status'].setValue(true);
      }
      if (this.form.controls['termografo_' + i + '_excesso_transit_time']) {
        this.form.controls['termografo_' + i + '_excesso_transit_time'].setValue(false);
        tg.excesso_transit_time = false;
      }
      if (this.form.controls['termografo_' + i + '_fora_alcance']) {
        this.form.controls['termografo_' + i + '_fora_alcance'].setValue(false);
        tg.fora_alcance = false;
      }
      if (this.form.controls['termografo_' + i + '_com_defeito']) {
        this.form.controls['termografo_' + i + '_com_defeito'].setValue(false);
        tg.com_defeito = false;
      }
      if (this.form.controls['termografo_' + i + '_fora_tolerancia']) {
        this.form.controls['termografo_' + i + '_fora_tolerancia'].setValue(false);
        tg.fora_tolerancia = false;
      }
    }
  }

  calcularDias() {
    if (this.laudo.data_embarque && this.laudo.data_chegada) {
      let d1 = new Date(this.laudo.data_embarque);
      let d2 = new Date(this.laudo.data_chegada);
      if (!isNaN(d1.getTime()) && !isNaN(d2.getTime())) {
        let timeDiff = d2.getTime() - d1.getTime();
        let diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
        this.laudo.bl_to_port = diffDays >= 0 ? diffDays : 0;
      } else {
        this.laudo.bl_to_port = null;
      }
    } else {
      this.laudo.bl_to_port = null;
    }
    if (this.form.controls['bl_to_port']) {
      this.form.controls['bl_to_port'].setValue(this.laudo.bl_to_port);
    }

    if (this.laudo.data_chegada && this.laudo.data_descarga) {
      let d1 = new Date(this.laudo.data_chegada);
      let d2 = new Date(this.laudo.data_descarga);
      if (!isNaN(d1.getTime()) && !isNaN(d2.getTime())) {
        let timeDiff = d2.getTime() - d1.getTime();
        let diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
        this.laudo.crt_to_house = diffDays >= 0 ? diffDays : 0;
      } else {
        this.laudo.crt_to_house = null;
      }
    } else {
      this.laudo.crt_to_house = null;
    }
    if (this.form.controls['crt_to_house']) {
      this.form.controls['crt_to_house'].setValue(this.laudo.crt_to_house);
    }
  }

  atualizarRotulagem() {
    let semRotulo = (this.laudo.sem_rotulo === true || (this.laudo.sem_rotulo as any) === 1 || (this.laudo.sem_rotulo as any) === '1');
    let rotuloDivergente = (this.laudo.rotulo_divergente === true || (this.laudo.rotulo_divergente as any) === 1 || (this.laudo.rotulo_divergente as any) === '1');
    
    let isConforme = (!semRotulo && !rotuloDivergente);
    
    this.laudo.rotulagem = isConforme;
    if (this.form.controls['rotulagem']) {
      this.form.controls['rotulagem'].setValue(isConforme);
    }
  }

  onSemCalibreChange(val: boolean) {
    if (val) {
      if (this.laudo.calibres) {
        this.laudo.calibres.forEach((item, i) => {
          item.calibre_min = true;
          item.calibre_max = true;
          item.calibre_med = true;
          item.calibre_afericao = true;
          
          if (this.form.controls['calibre_min_' + i]) {
            this.form.controls['calibre_min_' + i].setValue(true);
          }
          if (this.form.controls['calibre_max_' + i]) {
            this.form.controls['calibre_max_' + i].setValue(true);
          }
          if (this.form.controls['calibre_med_' + i]) {
            this.form.controls['calibre_med_' + i].setValue(true);
          }
          if (this.form.controls['calibre_afericao_' + i]) {
            this.form.controls['calibre_afericao_' + i].setValue(true);
          }
        });
      }
    }
  }

  onSemPesagemChange(val: boolean) {
    if (val) {
      this.laudo.peso_liquido_vol = true;
      if (this.form.controls['peso_liquido_vol']) {
        this.form.controls['peso_liquido_vol'].setValue(true);
      }
    } else {
      this.atualizarPesoLiquidoVol();
    }
  }

  atualizarMascaraEValidador(idTipoTransporte: any) {
    const control = this.form.get('identificacao_transporte');
    if (!control) return;

    if (idTipoTransporte == '217777894875648151') {
      this.mascaraTransporte = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
      control.setValidators([BasicValidators.containerNumber]);
    } else {
      this.mascaraTransporte = false;
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }

  getPesagemPesoMedio(pIdx: number): number {
    const pesagem = this.pesagens[pIdx];
    if (!pesagem) return null;
    const vols = pesagem.volumes || [];
    let validValues = [];
    vols.forEach((val) => {
      if (val !== null && val !== undefined && val !== '') {
        let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
        if (!isNaN(valFloat) && isFinite(valFloat)) {
          validValues.push(valFloat);
        }
      }
    });
    if (validValues.length > 0) {
      let sum = validValues.reduce((a, b) => a + b, 0);
      let avg = sum / validValues.length;
      
      let calcType = this.mercadoriaConfig ? this.mercadoriaConfig.laudo_tec_calc_peso : 'peso_liquido';
      if (calcType === 'peso_bruto') {
        return avg;
      } else { // peso_liquido or peso_drenado
        let taraVal = pesagem.tara;
        let tara = 0;
        if (taraVal !== null && taraVal !== undefined && taraVal !== '') {
          tara = typeof taraVal === 'string' ? parseFloat(taraVal.replace(',', '.')) : parseFloat(taraVal);
          if (isNaN(tara) || !isFinite(tara)) tara = 0;
        }
        return avg - tara;
      }
    }
    return null;
  }

  getPesagemVolumeTriplets(pIdx: number): any[] {
    const vols = this.pesagens[pIdx] ? this.pesagens[pIdx].volumes : [];
    let triplets = [];
    for (let i = 0; i < vols.length; i += 3) {
      let trip = [i];
      if (i + 1 < vols.length) trip.push(i + 1);
      if (i + 2 < vols.length) trip.push(i + 2);
      triplets.push(trip);
    }
    return triplets;
  }

  atualizarPesagemTriplets(pIdx: number) {
    const pesagem = this.pesagens[pIdx];
    if (!pesagem) return;
    const vols = pesagem.volumes || [];
    let triplets = [];
    for (let i = 0; i < vols.length; i += 3) {
      let trip = [i];
      if (i + 1 < vols.length) trip.push(i + 1);
      if (i + 2 < vols.length) trip.push(i + 2);
      triplets.push(trip);
    }
    pesagem.triplets = triplets;
  }

  pesoLiquidoValidador = (control: FormControl) => {
    if (!this.mercadoriaConfig || this.mercadoriaConfig.laudo_tec_exibir_peso_liquido === false) {
      return null;
    }
    const value = control.value;
    if (value === null || value === undefined) {
      return { required: true };
    }
    let strVal = String(value).trim();
    if (strVal === '') {
      return { required: true };
    }
    let floatVal = parseFloat(strVal.replace(',', '.'));
    if (isNaN(floatVal) || floatVal === 0) {
      return { required: true };
    }
    return null;
  };

  registrarControlesPesagem(pIdx: number, pesagemObj: any) {
    const isExibir = pesagemObj.exibir !== false && (pesagemObj.exibir as any) !== 'false' && (pesagemObj.exibir as any) !== 0 && (pesagemObj.exibir as any) !== '0';
    const exibirControl = new FormControl(isExibir, []);
    this.form.setControl(`pesagem_${pIdx}_exibir`, exibirControl);

    const taraControl = new FormControl(pesagemObj.tara || '', []);
    this.form.setControl(`pesagem_${pIdx}_tara`, taraControl);
    
    const pesoLiquidoControl = new FormControl(pesagemObj.peso_liquido || '', [this.pesoLiquidoValidador]);
    this.form.setControl(`pesagem_${pIdx}_peso_liquido`, pesoLiquidoControl);
    
    const diffControl = new FormControl(pesagemObj.diferenca_final || '', []);
    this.form.setControl(`pesagem_${pIdx}_diferenca_final`, diffControl);

    const pesoBrutoControl = new FormControl(pesagemObj.peso_bruto || '', []);
    this.form.setControl(`pesagem_${pIdx}_peso_bruto`, pesoBrutoControl);

    const pesoDrenadoControl = new FormControl(pesagemObj.peso_drenado || '', []);
    this.form.setControl(`pesagem_${pIdx}_peso_drenado`, pesoDrenadoControl);

    const vols = pesagemObj.volumes || [''];
    vols.forEach((vol, vIdx) => {
      const volControl = new FormControl(vol || '', []);
      this.form.setControl(`pesagem_${pIdx}_volume_${vIdx}`, volControl);
    });
  }

  removerControlesPesagem(pIdx: number, volumesCount: number) {
    this.form.removeControl(`pesagem_${pIdx}_exibir`);
    this.form.removeControl(`pesagem_${pIdx}_tara`);
    this.form.removeControl(`pesagem_${pIdx}_peso_liquido`);
    this.form.removeControl(`pesagem_${pIdx}_diferenca_final`);
    this.form.removeControl(`pesagem_${pIdx}_peso_bruto`);
    this.form.removeControl(`pesagem_${pIdx}_peso_drenado`);
    for (let vIdx = 0; vIdx < volumesCount; vIdx++) {
      this.form.removeControl(`pesagem_${pIdx}_volume_${vIdx}`);
    }
  }

  syncPesagensFromForm() {
    this.pesagens.forEach((pesagem, pIdx) => {
      const exibirControlName = `pesagem_${pIdx}_exibir`;
      if (this.form.controls[exibirControlName]) {
        pesagem.exibir = this.form.controls[exibirControlName].value;
      }
      const taraControlName = `pesagem_${pIdx}_tara`;
      if (this.form.controls[taraControlName]) {
        pesagem.tara = this.form.controls[taraControlName].value;
      }
      const pesoLiquidoControlName = `pesagem_${pIdx}_peso_liquido`;
      if (this.form.controls[pesoLiquidoControlName]) {
        pesagem.peso_liquido = this.form.controls[pesoLiquidoControlName].value;
      }
      const diffControlName = `pesagem_${pIdx}_diferenca_final`;
      if (this.form.controls[diffControlName]) {
        pesagem.diferenca_final = this.form.controls[diffControlName].value;
      }
      const pesoBrutoControlName = `pesagem_${pIdx}_peso_bruto`;
      if (this.form.controls[pesoBrutoControlName]) {
        pesagem.peso_bruto = this.form.controls[pesoBrutoControlName].value;
      }
      const pesoDrenadoControlName = `pesagem_${pIdx}_peso_drenado`;
      if (this.form.controls[pesoDrenadoControlName]) {
        pesagem.peso_drenado = this.form.controls[pesoDrenadoControlName].value;
      }
      pesagem.volumes.forEach((vol, vIdx) => {
        const volControlName = `pesagem_${pIdx}_volume_${vIdx}`;
        if (this.form.controls[volControlName]) {
          pesagem.volumes[vIdx] = this.form.controls[volControlName].value;
        }
      });
    });
  }

  rebuildPesagemControls() {
    Object.keys(this.form.controls).forEach(key => {
      if (key.startsWith('pesagem_') || key === 'peso_liquido' || key === 'exibir_pesagem') {
        this.form.removeControl(key);
      }
    });

    this.pesagens.forEach((pesagem, pIdx) => {
      this.registrarControlesPesagem(pIdx, pesagem);
    });
  }

  addPesagem() {
    const pIdx = this.pesagens.length;
    const newPesagem = {
      volumes: [''],
      tara: '',
      peso_liquido: '',
      diferenca_final: '',
      exibir: false
    };
    this.pesagens.push(newPesagem);
    this.registrarControlesPesagem(pIdx, newPesagem);
    this.atualizarPesagemTriplets(pIdx);
    this.atualizarPesoLiquidoVol();
  }

  removePesagem(pIdx: number) {
    if (this.pesagens.length > 1) {
      this.syncPesagensFromForm();
      
      this.pesagens.forEach((pesagem, idx) => {
        this.removerControlesPesagem(idx, pesagem.volumes.length);
      });

      this.pesagens.splice(pIdx, 1);

      this.rebuildPesagemControls();

      this.pesagens.forEach((_, idx) => {
        this.atualizarPesagemTriplets(idx);
      });
      this.atualizarPesoLiquidoVol();
    }
  }

  addPesagemVolume(pIdx: number) {
    const pesagem = this.pesagens[pIdx];
    if (pesagem && pesagem.volumes.length < 8) {
      const nextIdx = pesagem.volumes.length;
      pesagem.volumes.push('');
      
      const controlName = `pesagem_${pIdx}_volume_${nextIdx}`;
      let control = new FormControl('', []);
      this.form.setControl(controlName, control);
      
      this.atualizarPesagemTriplets(pIdx);
      this.calcularPesoMedio(pIdx);
      
      setTimeout(() => {
        let el = document.getElementById(controlName);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removePesagemVolume(pIdx: number, idx: number) {
    const pesagem = this.pesagens[pIdx];
    if (pesagem && pesagem.volumes.length > 1) {
      const lastIdx = pesagem.volumes.length - 1;
      this.form.removeControl(`pesagem_${pIdx}_volume_${lastIdx}`);

      pesagem.volumes.splice(idx, 1);

      pesagem.volumes.forEach((val, i) => {
        const controlName = `pesagem_${pIdx}_volume_${i}`;
        if (this.form.controls[controlName]) {
          this.form.controls[controlName].setValue(val);
        }
      });

      this.atualizarPesagemTriplets(pIdx);
      this.calcularPesoMedio(pIdx);
    }
  }

  calcularPesoMedio(pIdx: number) {
    this.calcularDiferencaFinal(pIdx);
  }

  calcularDiferencaFinal(pIdx: number) {
    const pesagem = this.pesagens[pIdx];
    if (!pesagem) return;

    let pesoMedio = this.getPesagemPesoMedio(pIdx);
    
    let calcType = this.mercadoriaConfig ? this.mercadoriaConfig.laudo_tec_calc_peso : 'peso_liquido';
    let targetPeso = 0;

    if (calcType === 'peso_bruto') {
      let pesoBrutoVal = this.form.controls[`pesagem_${pIdx}_peso_bruto`] ? this.form.controls[`pesagem_${pIdx}_peso_bruto`].value : null;
      if (pesoBrutoVal !== null && pesoBrutoVal !== undefined && pesoBrutoVal !== '') {
        targetPeso = typeof pesoBrutoVal === 'string' ? parseFloat(pesoBrutoVal.replace(',', '.')) : parseFloat(pesoBrutoVal);
        if (isNaN(targetPeso) || !isFinite(targetPeso)) targetPeso = 0;
      }
    } else if (calcType === 'peso_drenado') {
      let pesoDrenadoVal = this.form.controls[`pesagem_${pIdx}_peso_drenado`] ? this.form.controls[`pesagem_${pIdx}_peso_drenado`].value : null;
      if (pesoDrenadoVal !== null && pesoDrenadoVal !== undefined && pesoDrenadoVal !== '') {
        targetPeso = typeof pesoDrenadoVal === 'string' ? parseFloat(pesoDrenadoVal.replace(',', '.')) : parseFloat(pesoDrenadoVal);
        if (isNaN(targetPeso) || !isFinite(targetPeso)) targetPeso = 0;
      }
    } else { // peso_liquido
      let pesoLiquidoVal = this.form.controls[`pesagem_${pIdx}_peso_liquido`] ? this.form.controls[`pesagem_${pIdx}_peso_liquido`].value : null;
      if (pesoLiquidoVal !== null && pesoLiquidoVal !== undefined && pesoLiquidoVal !== '') {
        targetPeso = typeof pesoLiquidoVal === 'string' ? parseFloat(pesoLiquidoVal.replace(',', '.')) : parseFloat(pesoLiquidoVal);
        if (isNaN(targetPeso) || !isFinite(targetPeso)) targetPeso = 0;
      }
    }
    
    if (pesoMedio !== null && pesoMedio !== undefined) {
      let diff = pesoMedio - targetPeso;
      pesagem.diferenca_final = diff.toFixed(3);
      if (this.form.controls[`pesagem_${pIdx}_diferenca_final`]) {
        this.form.controls[`pesagem_${pIdx}_diferenca_final`].setValue(pesagem.diferenca_final);
      }
    } else {
      pesagem.diferenca_final = '';
      if (this.form.controls[`pesagem_${pIdx}_diferenca_final`]) {
        this.form.controls[`pesagem_${pIdx}_diferenca_final`].setValue('');
      }
    }
    this.atualizarPesoLiquidoVol();
  }

  atualizarPesoLiquidoVol() {
    if (this.laudo.sem_pesagem) {
      this.laudo.peso_liquido_vol = true;
      if (this.form.controls['peso_liquido_vol']) {
        this.form.controls['peso_liquido_vol'].setValue(true);
      }
      return;
    }
    let isConforme = true;
    this.pesagens.forEach((pesagem) => {
      const exibir = pesagem.exibir !== false && (pesagem.exibir as any) !== 'false' && (pesagem.exibir as any) !== 0 && (pesagem.exibir as any) !== '0';
      if (exibir) {
        let diffVal = pesagem.diferenca_final;
        let diff = 0;
        if (diffVal !== null && diffVal !== undefined && diffVal !== '') {
          diff = typeof diffVal === 'string' ? parseFloat(diffVal.replace(',', '.')) : parseFloat(diffVal);
        }
        if (diffVal !== null && diffVal !== undefined && diffVal !== '' && !isNaN(diff) && diff < 0) {
          isConforme = false;
        }
      }
    });

    this.laudo.peso_liquido_vol = isConforme;
    if (this.form.controls['peso_liquido_vol']) {
      this.form.controls['peso_liquido_vol'].setValue(isConforme);
    }
  }

  atualizarEstivagem() {
    let hasPorta = (this.laudo.carga_avancada_porta === true || (this.laudo.carga_avancada_porta as any) === 1 || (this.laudo.carga_avancada_porta as any) === '1');
    let hasTeto = (this.laudo.carga_avancada_teto === true || (this.laudo.carga_avancada_teto as any) === 1 || (this.laudo.carga_avancada_teto as any) === '1');
    
    let isConforme = (!hasPorta && !hasTeto);
    
    this.laudo.estivagem = isConforme;
    if (this.form.controls['estivagem']) {
      this.form.controls['estivagem'].setValue(isConforme);
    }
  }

  carregarPesagem() {
    this.pesagens = [];
    
    if (this.laudo.pesagem) {
      let parsed = typeof this.laudo.pesagem === 'string' ? JSON.parse(this.laudo.pesagem) : this.laudo.pesagem;
      if (Array.isArray(parsed)) {
        this.pesagens = parsed.map(p => {
          if (!p.hasOwnProperty('exibir')) {
            p.exibir = true;
          } else {
            p.exibir = p.exibir !== false && (p.exibir as any) !== 'false' && (p.exibir as any) !== 0 && (p.exibir as any) !== '0';
          }
          if (!p.volumes || p.volumes.length === 0) {
            p.volumes = [''];
          } else if (p.volumes.length > 8) {
            p.volumes = p.volumes.slice(0, 8);
          }
          return p;
        });
      } else if (parsed && typeof parsed === 'object') {
        let vols = parsed.volumes || [];
        if (vols.length === 0) {
          vols = [''];
        } else if (vols.length > 8) {
          vols = vols.slice(0, 8);
        }
        this.pesagens = [{
          volumes: vols,
          tara: parsed.tara || '',
          peso_liquido: this.laudo['peso_liquido'] || '',
          diferenca_final: parsed.diferenca_final || '',
          exibir: true
        }];
      }
    }
    
    if (this.pesagens.length === 0) {
      this.pesagens.push({
        volumes: [''],
        tara: '',
        peso_liquido: '',
        diferenca_final: '',
        exibir: false
      });
    }

    this.rebuildPesagemControls();
    
    this.pesagens.forEach((_, pIdx) => {
      this.atualizarPesagemTriplets(pIdx);
      this.calcularPesoMedio(pIdx);
    });
  }

  formatTemp(val: number): string {
    if (val === null || isNaN(val)) return '***';
    return val.toFixed(2).replace('.', ',');
  }

  formatPeso(val: number): string {
    if (val === null || isNaN(val)) return '***';
    return val.toFixed(3).replace('.', ',');
  }


  changeSetPoint(e) {
    if (e) {
      this.laudo.setpoint = '';
    }
  }

  changeAirTemperature(e) {
    if (e) {
      this.laudo.airtemperature = '';
    }
  }

  changeVentilacaoBLFechado(e) {
    if (e) {
      this.laudo.ventilacao_bl = '';
    }
  }

  changeVentilacaoContainer(e) {
    if (e) {
      this.laudo.ventilacao_container = '';
    }
  }

  changeVentilacaoContainerAutomatico(e) {
    if (e) {
      this.laudo.ventilacao_container = '';
      this.laudo.sem_ventilacao_container = false;
    }
  }

  uploadTermografoComplete(tg, resp, index: number = 1) {
    if (index === 1) {
      tg.has_foto = true;
    } else {
      tg['has_foto_' + index] = true;
    }
    this.cacheTimestamp = new Date().getTime();
  }

  apagaFotoTermografo(tg, index: number = 1) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: "Deseja realmente deletar a foto do termógrafo?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.laudosService.apagaFotoTermografo(self.laudo.id_laudo_tecnico, tg.id, index)
          .subscribe(json => {
            if (index === 1) {
              tg.has_foto = false;
            } else {
              tg['has_foto_' + index] = false;
            }
          }, erro => {
            self.func.showErro(erro.json());
          });
      });
  }

  girarFotoTermografo(tg, index: number = 1) {
    let self = this;
    this.laudosService.girarFotoTermografo(this.laudo.id_laudo_tecnico, tg.id, index)
      .subscribe(json => {
        this.cacheTimestamp = new Date().getTime();
        this.func.alerta(this.func.traduzir('front.sucesso'), this.func.traduzir('front.fotoRotacionadaComSucesso'), 'sucesso');
      }, erro => {
        this.func.showErro(erro.json());
      });
  }

  onExportadorChange(idExportador) {
    if (!idExportador || idExportador === 'null') {
      return;
    }
    const exportador = this.listExportadores.find(e => e.id == idExportador);
    if (exportador && exportador.id_pais && exportador.id_pais !== 'null' && exportador.id_pais !== 'undefined' && exportador.id_pais != 0) {
      let self = this;
      swal({
        title: this.func.traduzir('front.carregarPaisOrigem'),
        text: this.func.traduzir('front.confirmacaoCarregarPaisOrigem'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-success',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
        function () {
          self.laudo.id_pais_origem = exportador.id_pais;
          if (self.form.controls['id_pais_origem']) {
            self.form.controls['id_pais_origem'].setValue(exportador.id_pais);
          }
        });
    }
  }

  voltar() {
    this._location.back();
  }

  validateForm(form) {
    for (let i in form['controls']) {
      this.form['controls'][i].markAsTouched();
    }
  }

  save() {
    if (!this.form.valid) {
      this.validateForm(this.form);
      return;
    }
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.comentarios_cor === 'null' || values.comentarios_cor === '' || values.comentarios_cor === 'undefined' || values.comentarios_cor === null) {
      values.comentarios_cor = null;
    } else if (values.comentarios_cor !== undefined) {
      values.comentarios_cor = parseInt(values.comentarios_cor, 10);
    }

    if (this.laudo.identificacao_transporte && typeof this.laudo.identificacao_transporte === 'string') {
      this.laudo.identificacao_transporte = this.laudo.identificacao_transporte.trim();
    }
    if (values.identificacao_transporte && typeof values.identificacao_transporte === 'string') {
      values.identificacao_transporte = values.identificacao_transporte.trim();
    }

    this.syncTermografosFromForm();
    values.termografos = this.laudo.termografos;
    Object.keys(values).forEach(key => {
      if (key.startsWith('termografo_')) {
        delete values[key];
      }
    });

    this.syncCalibresFromForm();
    values.calibres = this.laudo.calibres;
    Object.keys(values).forEach(key => {
      if (key.startsWith('calibre_min_') || key.startsWith('calibre_max_') || key.startsWith('calibre_med_') || key.startsWith('calibre_afericao_')) {
        delete values[key];
      }
    });

    values.stakeholders = this.stakeholdersSelecionados.filter(id => id != null);
    values.responsaveis_tecnicos = this.responsaveisTecnicosSelecionados.filter(id => id != null);
    values.observacoes = this.observacoesSelecionadas.filter(id => id != null);
    
    let temps = [];
    for (let i = 0; i < this.temperaturasCount; i++) {
      let val = this.form.controls['temp_' + i].value;
      if (val !== null && val !== undefined && val !== '') {
        temps.push(val);
      }
    }
    values.temperaturas_polpa = temps;
    for (let i = 0; i < 9; i++) {
      delete values['temp_' + i];
    }

    let pressao = [];
    for (let i = 0; i < this.pressaoCount; i++) {
      let val = this.form.controls['pressao_' + i] ? this.form.controls['pressao_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        pressao.push(val);
      }
    }
    values.pressao_polpa = pressao;
    Object.keys(values).forEach(key => {
      if (key.startsWith('pressao_') && key !== 'pressao_polpa' && key !== 'pressao_poupa_status' && key !== 'pressao_polpa_exibir') {
        delete values[key];
      }
    });

    let brixList = [];
    for (let i = 0; i < this.brixCount; i++) {
      let val = this.form.controls['brix_' + i] ? this.form.controls['brix_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        brixList.push(val);
      }
    }
    values.brix = brixList;
    Object.keys(values).forEach(key => {
      if (key.startsWith('brix_') && key !== 'brix_status' && key !== 'brix_exibir') {
        delete values[key];
      }
    });

    let tamanhoCalibreList = [];
    for (let i = 0; i < this.tamanhoCalibreCount; i++) {
      let val = this.form.controls['tamanho_calibre_' + i] ? this.form.controls['tamanho_calibre_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        if (typeof val === 'string') {
          val = val.replace(/,/g, '.');
        }
        tamanhoCalibreList.push(val);
      }
    }
    values.tamanho_calibre = tamanhoCalibreList.join(',');
    Object.keys(values).forEach(key => {
      if (key.startsWith('tamanho_calibre_')) {
        delete values[key];
      }
    });

    let dataFabricacaoList = [];
    for (let i = 0; i < this.fabricacaoCount; i++) {
      let val = this.form.controls['data_fabricacao_' + i] ? this.form.controls['data_fabricacao_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        dataFabricacaoList.push(val);
      }
    }
    values.data_fabricacao = dataFabricacaoList;
    Object.keys(values).forEach(key => {
      if (key.startsWith('data_fabricacao_')) {
        delete values[key];
      }
    });

    let dataValidadeList = [];
    for (let i = 0; i < this.validadeCount; i++) {
      let val = this.form.controls['data_validade_' + i] ? this.form.controls['data_validade_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        dataValidadeList.push(val);
      }
    }
    values.data_validade = dataValidadeList;
    Object.keys(values).forEach(key => {
      if (key.startsWith('data_validade_')) {
        delete values[key];
      }
    });

    this.syncPesagensFromForm();
    let compiledPesagens = [];
    this.pesagens.forEach((pesagem) => {
      let vols = [];
      pesagem.volumes.forEach((vol) => {
        if (vol !== null && vol !== undefined && vol !== '') {
          vols.push(vol);
        }
      });
      compiledPesagens.push({
        volumes: vols,
        tara: pesagem.tara,
        peso_liquido: pesagem.peso_liquido,
        diferenca_final: pesagem.diferenca_final,
        exibir: pesagem.exibir,
        peso_bruto: pesagem.peso_bruto,
        peso_drenado: pesagem.peso_drenado
      });
    });
    values.pesagem = compiledPesagens;
    
    Object.keys(values).forEach(key => {
      if (key.startsWith('pesagem_') || key === 'peso_liquido') {
        delete values[key];
      }
    });

    values.labels = this.labelsSelecionados.filter(id => id != null);
    values.labels_defeitos = this.labelsDefeitosSelecionados.filter(id => id != null);
    values.fotos = this.listFotos;
    values.defeitos = this.listDefeitos;
    values.ordem_categorias = this.getCategoriasSelecionadasObj().map(c => c.uid);
    values.odr_valores = this.odr_valores;
    values.indices_conclusao = this.indicesConclusaoSelecionados;
    Object.keys(values).forEach(key => {
      if (key.startsWith('indiceConclusao')) {
        delete values[key];
      }
    });

    if (values.id_laudo_tecnico || this.pageIsUpd) {
      const labelsSemFotos = this.getLabelsTradicionaisSemFotos();
      if (labelsSemFotos && labelsSemFotos.length > 0) {
        let self = this;
        let listaLabelsHtml = labelsSemFotos.map(nome => `<li style="text-align: left; margin-bottom: 4px;"><strong>${nome}</strong></li>`).join('');
        let avisoTxt = this.func.traduzir('front.avisoLabelsTradicionaisSemFotos');
        let perguntaTxt = this.func.traduzir('front.desejaSalvarEdicaoMesmoAssim');
        let mensagemHtml = `<div style="text-align: left; margin-top: 10px;">
          <p style="margin-bottom: 10px;">${avisoTxt}</p>
          <ul style="padding-left: 20px; margin-bottom: 15px;">
            ${listaLabelsHtml}
          </ul>
          <p style="margin-bottom: 0;">${perguntaTxt}</p>
        </div>`;

        swal({
          title: this.func.traduzir('front.atencao'),
          text: mensagemHtml,
          html: true,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: 'btn-warning',
          confirmButtonText: this.func.traduzir('front.editarMesmoAssim'),
          cancelButtonText: this.func.traduzir('front.cancelar'),
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (isConfirm) {
          if (isConfirm) {
            self.proceedSave(values);
          } else {
            self.enviando = false;
          }
        });
        return;
      }
    }

    this.proceedSave(values);
  }

  getLabelsTradicionaisSemFotos(): string[] {
    const selectedLabelIds = (this.labelsSelecionados || []).filter(id => id != null && id !== '' && id !== 'null');
    if (!selectedLabelIds || selectedLabelIds.length === 0) {
      return [];
    }

    const labelsSemFotos: string[] = [];

    selectedLabelIds.forEach(labelId => {
      const hasFoto = (this.listFotos || []).some(f => {
        const matchesId = f.id_label_foto != null && String(f.id_label_foto) === String(labelId);
        const matchesCat = f._categoria_id === ('label:' + labelId);
        return matchesId || matchesCat;
      });

      if (!hasFoto) {
        let labelObj = this.listLabelsFotos ? this.listLabelsFotos.find(l => String(l.id) === String(labelId)) : null;
        if (!labelObj && this.laudo && this.laudo['labels']) {
          labelObj = this.laudo['labels'].find(l => String(l.id) === String(labelId));
        }
        const nome = labelObj ? (labelObj.nome_pt || labelObj.nome || labelObj.nome_en || labelObj.nome_es || ('Label #' + labelId)) : ('Label #' + labelId);
        labelsSemFotos.push(nome);
      }
    });

    return labelsSemFotos;
  }

  proceedSave(values: any) {
    this.enviando = true;
    if (values.id_laudo_tecnico) {
      this.laudosService.editar(values, values.id_laudo_tecnico)
        .subscribe(data => this.router.navigate(['/painel', 'laudos-tecnicos']),
          error => {
            this.enviando = false;
            let json = error.json();
            this.func.showErro(json);

            if (json.Message && json.Message.ErrorInput) {
              for (let i in json.Message.ErrorInput) {
                let erro = {};
                erro[i] = json.Message.ErrorInput[i];
                this.form.controls[i].setErrors(erro);
              }
            }
          });
    } else {
      this.laudosService.adicionar(values)
        .subscribe(data => {
          this.router.navigate(['/painel', 'laudos-tecnicos', data.Payload, 'upd'], { queryParams: { abafotos: '1' } });
        },
          error => {
            this.enviando = false;
            let json = error.json();
            this.func.showErro(json);

            if (json.Message && json.Message.ErrorInput) {
              for (let i in json.Message.ErrorInput) {
                let erro = {};
                erro[i] = json.Message.ErrorInput[i];
                this.form.controls[i].setErrors(erro);
              }
            }
          });
    }
  }

  loadVenobox() {
    $('.venobox').venobox();
  }

  ordenouFotos(e) {
    for (let i in this.listFotos) {
      this.listFotos[i].ordem = parseInt(i) + 1;
    }
  }

  apagaFoto(indice) {
    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFoto'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.laudosService.apagaFoto(self.laudo.id_laudo_tecnico, self.listFotos[indice].id_foto)
          .subscribe(json => {
            self.listFotos.splice(indice, 1);
          }, erro => {
            self.laudosService.trataErro(erro.json());
          });
      });
  }

  girarFoto(indice) {
    let self = this;
    let foto = this.listFotos[indice];
    this.laudosService.girarFoto(this.laudo.id_laudo_tecnico, foto.id_foto)
      .subscribe(json => {
        foto.timestamp = new Date().getTime();
        setTimeout(() => {
          self.loadVenobox();
        }, 100);
        this.func.alerta(this.func.traduzir('front.sucesso'), this.func.traduzir('front.fotoRotacionadaComSucesso'), 'sucesso');
      }, erro => {
        this.laudosService.trataErro(erro.json());
      });
  }

  uploadFotosComplete(resp) {
    try {
      let payload = JSON.parse(resp).Payload;
      if (payload) {
        if (Array.isArray(payload)) {
          for (let f of payload) {
            f.id_label_foto = null;
            f.id_defeito = null;
            f._categoria_id = null;
            this.listFotos.push(f);
          }
        } else {
          payload.id_label_foto = null;
          payload.id_defeito = null;
          payload._categoria_id = null;
          this.listFotos.push(payload);
        }
      }
    }
    catch (e) { }
  }

  baixarFotosZip() {
    this.laudosService.zipFotos(this.laudo.id_laudo_tecnico)
      .subscribe(json => {
        window.open(this.laudosService.dominio + json.Payload[0], '_blank');
      });
  }

  getFotosByLabel(labelId: any) {
    return this.listFotos.filter(f => f.id_label_foto == labelId);
  }

  getFotosByCategoria(catUid: string) {
    return this.listFotos.filter(f => {
      const currentUid = f.id_label_foto ? 'label:' + f.id_label_foto : (f.id_defeito ? 'defeito:' + f.id_defeito : null);
      return currentUid === catUid;
    });
  }

  getFotoIndex(id_foto: any) {
    return this.listFotos.findIndex(f => f.id_foto == id_foto);
  }

  alterouLabelFoto(foto: any) {
    if (foto._categoria_id) {
      const parts = foto._categoria_id.split(':');
      if (parts[0] === 'label') {
        foto.id_label_foto = parts[1];
        foto.id_defeito = null;
      } else {
        foto.id_defeito = parts[1];
        foto.id_label_foto = null;
      }
    } else {
      foto.id_label_foto = null;
      foto.id_defeito = null;
    }
  }

  addLabelSelecionado() {
    let totalDisponivel = this.listLabelsFotos ? this.listLabelsFotos.length : 0;
    if (this.labelsSelecionados.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), 'Todos os itens já foram adicionados', 'erro');
      return;
    }
    this.labelsSelecionados.push(null);
  }

  removeLabelSelecionado(i: number) {
    this.labelsSelecionados.splice(i, 1);
  }

  addLabelDefeitoSelecionado() {
    let totalDisponivel = this.listDefeitos ? this.listDefeitos.length : 0;
    if (this.labelsDefeitosSelecionados.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), 'Todos os itens já foram adicionados', 'erro');
      return;
    }
    this.labelsDefeitosSelecionados.push(null);
  }

  removeLabelDefeitoSelecionado(i: number) {
    this.labelsDefeitosSelecionados.splice(i, 1);
  }

  getLabelsSelecionadosObj() {
    return this.listLabelsFotos.filter(lbl => this.labelsSelecionados.indexOf(lbl.id) > -1);
  }

  private _cachedLabelsHash = '';
  private _cachedCategorias = [];

  getCategoriasSelecionadasObj() {
    const hash = JSON.stringify(this.labelsSelecionados || []) + '|' + JSON.stringify(this.labelsDefeitosSelecionados || []) + '|' + (this.listLabelsFotos ? this.listLabelsFotos.length : 0) + '|' + (this.listDefeitos ? this.listDefeitos.length : 0) + '|' + JSON.stringify(this.ordemCategorias || []);
    if (hash !== this._cachedLabelsHash) {
      this._cachedLabelsHash = hash;
      let list = [];

      // Add standard labels
      if (this.listLabelsFotos && this.labelsSelecionados) {
        this.listLabelsFotos.forEach(lbl => {
          if (this.labelsSelecionados.indexOf(lbl.id) > -1) {
            list.push({
              uid: 'label:' + lbl.id,
              nome_pt: lbl.nome_pt,
              type: 'label',
              id: lbl.id
            });
          }
        });
      }

      // Add defect labels
      if (this.listDefeitos && this.labelsDefeitosSelecionados) {
        this.listDefeitos.forEach(def => {
          if (this.labelsDefeitosSelecionados.indexOf(def.id_defeito) > -1) {
            list.push({
              uid: 'defeito:' + def.id_defeito,
              nome_pt: def.nome_pt,
              type: 'defeito',
              id: def.id_defeito
            });
          }
        });
      }

      // Sort the list based on their index in this.ordemCategorias
      list.sort((a, b) => {
        let idxA = this.ordemCategorias.indexOf(a.uid);
        let idxB = this.ordemCategorias.indexOf(b.uid);
        if (idxA === -1) idxA = 999;
        if (idxB === -1) idxB = 999;
        return idxA - idxB;
      });

      this._cachedCategorias = list;
    }
    return this._cachedCategorias;
  }

  moverCategoria(index: number, direcao: number) {
    let cats = this.getCategoriasSelecionadasObj();
    let targetIndex = index + direcao;
    if (targetIndex < 0 || targetIndex >= cats.length) {
      return;
    }

    // Ensure all currently selected category UIDs are in this.ordemCategorias
    let currentUids = cats.map(c => c.uid);
    this.ordemCategorias = currentUids;

    // Swap the elements in this.ordemCategorias
    let temp = this.ordemCategorias[index];
    this.ordemCategorias[index] = this.ordemCategorias[targetIndex];
    this.ordemCategorias[targetIndex] = temp;
  }

  getLabelsDisponiveis(indexAtual: number) {
    if (!this.listLabelsFotos) return [];
    return this.listLabelsFotos.filter(lbl => {
      const matchesMercadoria = lbl.mercadorias && lbl.mercadorias.some(m => this.laudo.id_produto && String(m.id) === String(this.laudo.id_produto));
      if (!matchesMercadoria) {
        return false;
      }
      let findIdx = this.labelsSelecionados.indexOf(lbl.id);
      return findIdx === -1 || findIdx === indexAtual;
    });
  }

  getDefeitosDisponiveis(indexAtual: number) {
    if (!this.listDefeitos) return [];
    return this.listDefeitos.filter(def => {
      let findIdx = this.labelsDefeitosSelecionados.indexOf(def.id_defeito);
      return findIdx === -1 || findIdx === indexAtual;
    });
  }

  modalGerenciarCategorias() {
    $('#modalCategorias').modal('show');
  }

  changeDefeitos(i, e) {
    if (this.listDefeitos[i] && parseFloat(this.listDefeitos[i].valor) > 100) {
      this.listDefeitos[i].valor = 100;
      if (this.form && this.form.controls && this.form.controls['defeito' + i]) {
        this.form.controls['defeito' + i].setValue(100, { emitEvent: false });
      }
    }
    this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);

    // Se for índice acumulado, atualiza o estado ativo de todos os sub-defeitos
    if (this.listDefeitos[i].is_indice_acumulado) {
      let subDefeitos = this.getSubDefeitos(this.listDefeitos[i]);
      for (let sub of subDefeitos) {
        let subIdx = this.getDefeitoIndex(sub.id_defeito);
        if (subIdx !== -1) {
          this.listDefeitos[subIdx].ativo = e;
          if (this.form && this.form.controls && this.form.controls['defeitoAtivo' + subIdx]) {
            this.form.controls['defeitoAtivo' + subIdx].setValue(e);
          }
          if (e === false) {
            this.listDefeitos[subIdx].valor = 0;
            if (this.form && this.form.controls && this.form.controls['defeito' + subIdx]) {
              this.form.controls['defeito' + subIdx].setValue(0);
            }
          }
        }
      }
      this.recalculaIndiceAcumulado(this.listDefeitos[i].id_defeito);
    }

    // verificar se ele faz parte de algum indice acumulado
    for (let c in this.listDefeitos) {
      if (this.listDefeitos[c].is_indice_acumulado) {
        for (let z in this.listDefeitos[c].indices_acumulados) {
          if (this.listDefeitos[c].indices_acumulados[z].id_defeito_indice == this.listDefeitos[i].id_defeito) {
            this.recalculaIndiceAcumulado(this.listDefeitos[c].id_defeito);
          }
        }
      }
    }

    this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
    this.calcularODR();
  }

  recalculaIndiceAcumulado(id_defeito) {
    let valor = 0;

    for (let i in this.listDefeitos) {
      if (this.listDefeitos[i].id_defeito == id_defeito) {
        for (let z in this.listDefeitos[i].indices_acumulados) {

          // busca os ids dos indices calculados para pegar o valor atual
          for (let q in this.listDefeitos) {
            if (this.listDefeitos[i].indices_acumulados[z].id_defeito_indice == this.listDefeitos[q].id_defeito) {
              valor = valor + parseFloat(this.listDefeitos[q].valor);
            }
          }
        }
      }
    }

    if (valor > 100) {
      valor = 100;
    }

    for (let q in this.listDefeitos) {
      if (id_defeito == this.listDefeitos[q].id_defeito) {
        this.listDefeitos[q].valor = valor;
        this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
      }
    }
  }

  formatValor(valor: any): string {
    if (valor === undefined || valor === null) {
      return '0,00';
    }
    let parsed = parseFloat(valor);
    if (isNaN(parsed)) {
      return '0,00';
    }
    return parsed.toFixed(2).replace('.', ',');
  }

  getDefeitoIndex(id_defeito: any) {
    return this.listDefeitos.findIndex(d => d.id_defeito == id_defeito);
  }

  getSubDefeitos(defeitoAcumulado: any) {
    let list = [];
    if (defeitoAcumulado && defeitoAcumulado.indices_acumulados) {
      for (let sub of defeitoAcumulado.indices_acumulados) {
        let found = this.listDefeitos.find(d => d.id_defeito == sub.id_defeito_indice);
        if (found) {
          list.push(found);
        }
      }
    }
    return list.sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  defeitoPertenceAAlgumAcumulado(defeitoId: any): boolean {
    for (let d of this.listDefeitos) {
      if (d.is_indice_acumulado && d.indices_acumulados) {
        for (let sub of d.indices_acumulados) {
          if (sub.id_defeito_indice == defeitoId) {
            return true;
          }
        }
      }
    }
    return false;
  }

  temDefeitosSemIndiceAcumulado(): boolean {
    if (!this.listDefeitos) return false;
    return this.listDefeitos.some(d => !d.is_indice_acumulado && !this.defeitoPertenceAAlgumAcumulado(d.id_defeito));
  }

  calcularODR() {
    if (!this.formula_odr) {
      this.odr_calculado = null;
      return;
    }

    let expr = this.formula_odr;

    // 1. Substituir defeitos e índices acumulados {def_ID} pelo valor
    const defRegex = /\{def_(\d+)(?:\|[^}]+)?\}/g;
    expr = expr.replace(defRegex, (match, defId) => {
      const found = this.listDefeitos.find(d => String(d.id_defeito) === String(defId));
      return found ? String(found.valor || 0) : '0';
    });

    // 2. Substituir inputs customizados {input_CHAVE} pelo valor
    const inputRegex = /\{input_([a-zA-Z0-9_]+)\}/g;
    expr = expr.replace(inputRegex, (match, chave) => {
      const val = this.odr_valores[chave];
      return val !== undefined && val !== null ? String(val) : '0';
    });

    // 3. Substituir × por * e outros caracteres permitidos
    expr = expr.replace(/×/g, '*').replace(/x/g, '*').replace(/X/g, '*');

    // 4. Sanitizar tudo que não for operador matemático válido ou número
    const sanitizedExpr = expr.replace(/[^0-9\+\-\*\/\(\)\. ]/g, '');

    try {
      // Usar a Function constructor para avaliar de forma segura na sandbox
      const res = new Function(`return (${sanitizedExpr})`)();
      this.odr_calculado = typeof res === 'number' && isFinite(res) ? parseFloat(res.toFixed(2)) : 0;
    } catch (e) {
      console.error("Erro ao calcular ODR:", e);
      this.odr_calculado = 0;
    }
  }

  getInputLabel(item: any): string {
    const lang = this.translateService.currentLang || 'pt';
    if (lang === 'en') {
      return item.label_en || item.label_pt || item.label || item.chave;
    } else if (lang === 'es') {
      return item.label_es || item.label_pt || item.label || item.chave;
    } else {
      return item.label_pt || item.label || item.chave;
    }
  }

  getSiglaUnidadeMedidaCalibre(): string {
    const umId = this.mercadoriaConfig ? this.mercadoriaConfig.laudo_tec_id_unidade_medida : null;
    if (umId && this.listTodasUnidadesMedidas) {
      const um = this.listTodasUnidadesMedidas.find(item => String(item.id_unidade) === String(umId));
      if (um) {
        return um.sigla || '';
      }
    }
    return '';
  }

  criarNovoItemCalibre() {
    const comValores = this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_layout_calibre_com_valores === true;
    if (comValores) {
      return {
        calibre_min: '',
        calibre_max: '',
        calibre_afericao: true
      };
    } else {
      return {
        calibre_min: true,
        calibre_max: true,
        calibre_med: true
      };
    }
  }

  rebuildCalibresControls() {
    this.syncCalibresFromForm();

    if (!this.laudo) {
      return;
    }

    if (!this.laudo.calibres || !Array.isArray(this.laudo.calibres)) {
      this.laudo.calibres = [];
    }

    const parseBoolean = (val, defaultVal = true) => {
      if (val === undefined || val === null || val === '') {
        return defaultVal;
      }
      if (val === true || val === 'true' || val === 1 || val === '1') {
        return true;
      }
      if (val === false || val === 'false' || val === 0 || val === '0') {
        return false;
      }
      return defaultVal;
    };

    if (!this.mercadoriaConfig) {
      if (this.laudo.calibres.length === 0) {
        this.laudo.calibres.push(this.criarNovoItemCalibre());
      }
      this.laudo.calibres.forEach((item, i) => {
        const isNumericMin = item.calibre_min !== null && item.calibre_min !== undefined && item.calibre_min !== '' && typeof item.calibre_min !== 'boolean' && !isNaN(Number(String(item.calibre_min).replace(',', '.')));
        if (!isNumericMin) {
          item.calibre_min = parseBoolean(item.calibre_min, true);
        }
        const isNumericMax = item.calibre_max !== null && item.calibre_max !== undefined && item.calibre_max !== '' && typeof item.calibre_max !== 'boolean' && !isNaN(Number(String(item.calibre_max).replace(',', '.')));
        if (!isNumericMax) {
          item.calibre_max = parseBoolean(item.calibre_max, true);
        }
        item.calibre_med = parseBoolean(item.calibre_med, true);
        item.calibre_afericao = parseBoolean(item.calibre_afericao, true);

        this.form.setControl('calibre_min_' + i, new FormControl(item.calibre_min, []));
        this.form.setControl('calibre_max_' + i, new FormControl(item.calibre_max, []));
        this.form.setControl('calibre_med_' + i, new FormControl(item.calibre_med, []));
        this.form.setControl('calibre_afericao_' + i, new FormControl(item.calibre_afericao, []));
      });
      return;
    }

    const multiplo = this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_calibre_multiplo === true;
    if (multiplo) {
      // Garante que o número de calibres seja exatamente igual ao tamanhoCalibreCount
      while (this.laudo.calibres.length < this.tamanhoCalibreCount) {
        this.laudo.calibres.push(this.criarNovoItemCalibre());
      }
      if (this.laudo.calibres.length > this.tamanhoCalibreCount) {
        this.laudo.calibres = this.laudo.calibres.slice(0, this.tamanhoCalibreCount);
      }
    } else {
      // Se não for múltiplo, garante que tenha exatamente 1 item
      if (this.laudo.calibres.length === 0) {
        this.laudo.calibres.push(this.criarNovoItemCalibre());
      } else if (this.laudo.calibres.length > 1) {
        this.laudo.calibres = [this.laudo.calibres[0]];
      }
    }

    // Remove controles antigos além do tamanho atual
    Object.keys(this.form.controls).forEach(key => {
      if (key.startsWith('calibre_min_') || key.startsWith('calibre_max_') || key.startsWith('calibre_med_') || key.startsWith('calibre_afericao_')) {
        const parts = key.split('_');
        const idx = parseInt(parts[parts.length - 1], 10);
        if (isNaN(idx) || idx >= this.laudo.calibres.length) {
          this.form.removeControl(key);
        }
      }
    });

    // Registra os novos controles
    const comValores = this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_layout_calibre_com_valores === true;
    this.laudo.calibres.forEach((item, i) => {
      if (comValores) {
        item.calibre_afericao = parseBoolean(item.calibre_afericao, true);

        if (item.calibre_min !== null && item.calibre_min !== undefined && item.calibre_min !== '' && typeof item.calibre_min !== 'boolean') {
          let num = typeof item.calibre_min === 'string' ? parseFloat(item.calibre_min.replace(',', '.')) : parseFloat(item.calibre_min);
          item.calibre_min = !isNaN(num) ? parseFloat(num.toFixed(2)) : null;
        } else if (typeof item.calibre_min === 'boolean') {
          item.calibre_min = null;
        }

        if (item.calibre_max !== null && item.calibre_max !== undefined && item.calibre_max !== '' && typeof item.calibre_max !== 'boolean') {
          let num = typeof item.calibre_max === 'string' ? parseFloat(item.calibre_max.replace(',', '.')) : parseFloat(item.calibre_max);
          item.calibre_max = !isNaN(num) ? parseFloat(num.toFixed(2)) : null;
        } else if (typeof item.calibre_max === 'boolean') {
          item.calibre_max = null;
        }

        this.form.setControl('calibre_min_' + i, new FormControl(item.calibre_min !== undefined && item.calibre_min !== null ? item.calibre_min : '', []));
        this.form.setControl('calibre_max_' + i, new FormControl(item.calibre_max !== undefined && item.calibre_max !== null ? item.calibre_max : '', []));
        this.form.setControl('calibre_afericao_' + i, new FormControl(item.calibre_afericao, []));
      } else {
        item.calibre_min = parseBoolean(item.calibre_min, true);
        item.calibre_max = parseBoolean(item.calibre_max, true);
        item.calibre_med = parseBoolean(item.calibre_med, true);

        this.form.setControl('calibre_min_' + i, new FormControl(item.calibre_min, []));
        this.form.setControl('calibre_max_' + i, new FormControl(item.calibre_max, []));
        this.form.setControl('calibre_med_' + i, new FormControl(item.calibre_med, []));
      }
    });
  }

  addCalibre() {
    this.syncCalibresFromForm();
    if (this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_calibre_multiplo === true) {
      this.laudo.calibres.push(this.criarNovoItemCalibre());
      this.rebuildCalibresControls();
    }
  }

  removeCalibre(index: number) {
    this.syncCalibresFromForm();
    if (this.laudo.calibres && this.laudo.calibres.length > 1) {
      this.laudo.calibres.splice(index, 1);
      this.rebuildCalibresControls();
    }
  }

  syncCalibresFromForm() {
    if (!this.laudo || !this.laudo.calibres || !Array.isArray(this.laudo.calibres) || !this.mercadoriaConfig) {
      return;
    }
    const comValores = this.mercadoriaConfig && this.mercadoriaConfig.laudo_tec_layout_calibre_com_valores === true;
    this.laudo.calibres.forEach((item, i) => {
      const minCtrl = this.form.controls['calibre_min_' + i];
      const maxCtrl = this.form.controls['calibre_max_' + i];

      if (comValores) {
        if (minCtrl && minCtrl.value !== undefined && minCtrl.value !== null && minCtrl.value !== '') {
          const minVal = minCtrl.value;
          if (typeof minVal !== 'boolean') {
            let numMin = typeof minVal === 'string' ? parseFloat(minVal.replace(',', '.')) : parseFloat(minVal);
            item.calibre_min = !isNaN(numMin) ? parseFloat(numMin.toFixed(2)) : null;
          } else {
            item.calibre_min = null;
          }
        }

        if (maxCtrl && maxCtrl.value !== undefined && maxCtrl.value !== null && maxCtrl.value !== '') {
          const maxVal = maxCtrl.value;
          if (typeof maxVal !== 'boolean') {
            let numMax = typeof maxVal === 'string' ? parseFloat(maxVal.replace(',', '.')) : parseFloat(maxVal);
            item.calibre_max = !isNaN(numMax) ? parseFloat(numMax.toFixed(2)) : null;
          } else {
            item.calibre_max = null;
          }
        }

        const afericaoCtrl = this.form.controls['calibre_afericao_' + i];
        if (afericaoCtrl && afericaoCtrl.value !== undefined && afericaoCtrl.value !== null && afericaoCtrl.value !== '') {
          item.calibre_afericao = afericaoCtrl.value !== false && afericaoCtrl.value !== 'false' && afericaoCtrl.value !== 0 && afericaoCtrl.value !== '0';
        }
      } else {
        if (minCtrl && minCtrl.value !== undefined && minCtrl.value !== null && minCtrl.value !== '') {
          item.calibre_min = minCtrl.value === true || minCtrl.value === 'true' || minCtrl.value === 1 || minCtrl.value === '1';
        }
        if (maxCtrl && maxCtrl.value !== undefined && maxCtrl.value !== null && maxCtrl.value !== '') {
          item.calibre_max = maxCtrl.value === true || maxCtrl.value === 'true' || maxCtrl.value === 1 || maxCtrl.value === '1';
        }
        const medCtrl = this.form.controls['calibre_med_' + i];
        if (medCtrl && medCtrl.value !== undefined && medCtrl.value !== null && medCtrl.value !== '') {
          item.calibre_med = medCtrl.value === true || medCtrl.value === 'true' || medCtrl.value === 1 || medCtrl.value === '1';
        }
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/laudos-tecnicos/laudos-tecnicos-form.component.ts